//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class TokenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    echo(): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/echo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEcho(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEcho(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processEcho(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    environment(): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnvironment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnvironment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processEnvironment(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processToken(authParam: AuthParam): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processProcessToken(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setupMFA(setup: AuthMFASetup): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/setup/mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetupMFA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetupMFA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processSetupMFA(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateMFA(code: string): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(code);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateMFA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateMFA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processValidateMFA(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    expireToken(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/token/ExpireToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpireToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpireToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExpireToken(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshToken(): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/Refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    renewToken(): Observable<AuthSecContextInt> {
        let url_ = this.baseUrl + "/api/v1/token/Renew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContextInt>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContextInt>;
        }));
    }

    protected processRenewToken(response: HttpResponseBase): Observable<AuthSecContextInt> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContextInt.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getRoles(): Observable<RoleV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/roles/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleV1Model[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApiPermissions(): Observable<APIPermissionModel[]> {
        let url_ = this.baseUrl + "/api/v1/roles/apiPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<APIPermissionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APIPermissionModel[]>;
        }));
    }

    protected processGetApiPermissions(response: HttpResponseBase): Observable<APIPermissionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(APIPermissionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRolePermissions(roleId: number | undefined): Observable<APIPermissionModel[]> {
        let url_ = this.baseUrl + "/api/v1/roles/rolePermissions?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<APIPermissionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APIPermissionModel[]>;
        }));
    }

    protected processGetRolePermissions(response: HttpResponseBase): Observable<APIPermissionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(APIPermissionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserRoles(userId: number): Observable<RoleV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/roles/roles/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleV1Model[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<RoleV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignUserRole(userId: number, roleId: number): Observable<UserUpdateV1Model> {
        let url_ = this.baseUrl + "/api/v1/roles/roles/assign/{userId}/{roleId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserUpdateV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserUpdateV1Model>;
        }));
    }

    protected processAssignUserRole(response: HttpResponseBase): Observable<UserUpdateV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserUpdateV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PasswordClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    beginResetPassword(email: string): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processBeginResetPassword(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(request: ResetPasswordV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordAuthenticated(request: ResetPasswordV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword/Authenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processResetPasswordAuthenticated(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordUser(userId: number, password: string): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword/User/{userId}/{password}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{password}", encodeURIComponent("" + password));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processResetPasswordUser(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUser(): Observable<UserV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserId(): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/user/id";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUserId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(user_id: number): Observable<UserV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/{user_id}";
        if (user_id === undefined || user_id === null)
            throw new Error("The parameter 'user_id' must be defined.");
        url_ = url_.replace("{user_id}", encodeURIComponent("" + user_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<UserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsers(): Observable<UserV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/user/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: UserSearchV1Model): Observable<PageableListV1ModelOfUserV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageableListV1ModelOfUserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageableListV1ModelOfUserV1Model>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PageableListV1ModelOfUserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageableListV1ModelOfUserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertUser(model: UserInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsertUser(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(model: UserUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(userId: number): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserSettings(): Observable<UserSettingV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/user/UserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingV1Model[]>;
        }));
    }

    protected processGetUserSettings(response: HttpResponseBase): Observable<UserSettingV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSettingV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserSetting(setting: UserSettingV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/UpdateUserSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateUserSetting(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserSettings(settings: UserSettingV1Model[]): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/UpdateUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateUserSettings(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        let url_ = this.baseUrl + "/api/UserOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfUserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        let url_ = this.baseUrl + "/api/UserOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfUserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SkillLevelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<SkillLevelV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/skill-levels/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillLevelV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillLevelV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SkillLevelV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SkillLevelV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(skillLevelId: number): Observable<SkillLevelV1Model> {
        let url_ = this.baseUrl + "/api/v1/skill-levels/{skillLevelId}";
        if (skillLevelId === undefined || skillLevelId === null)
            throw new Error("The parameter 'skillLevelId' must be defined.");
        url_ = url_.replace("{skillLevelId}", encodeURIComponent("" + skillLevelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillLevelV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillLevelV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<SkillLevelV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillLevelV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: SkillLevelInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/skill-levels/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: SkillLevelUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/skill-levels/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SkillLevelODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfSkillLevelV1Model> {
        let url_ = this.baseUrl + "/api/SkillLevelOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfSkillLevelV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfSkillLevelV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfSkillLevelV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfSkillLevelV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfSkillLevelV1Model> {
        let url_ = this.baseUrl + "/api/SkillLevelOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfSkillLevelV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfSkillLevelV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfSkillLevelV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfSkillLevelV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SkillLevelCostODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model> {
        let url_ = this.baseUrl + "/api/SkillLevelCostOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfSkillLevelCostV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model> {
        let url_ = this.baseUrl + "/api/SkillLevelCostOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfSkillLevelCostV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfSkillLevelCostV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobWorkflowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: JobWorkflowInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-workflow/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByJobId(jobId: number): Observable<JobWorkflowV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/job-workflow/GetAllByJobId/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobWorkflowV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobWorkflowV1Model[]>;
        }));
    }

    protected processGetAllByJobId(response: HttpResponseBase): Observable<JobWorkflowV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobWorkflowV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(model: UncheckV1Model): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-workflow/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<JobV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/jobs/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<JobV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActive(): Observable<JobV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/jobs/GetActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobV1Model[]>;
        }));
    }

    protected processGetActive(response: HttpResponseBase): Observable<JobV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobId: number): Observable<JobV1Model> {
        let url_ = this.baseUrl + "/api/v1/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSummaryByID(jobId: number): Observable<JobSummaryInfoV1Model> {
        let url_ = this.baseUrl + "/api/v1/jobs/{jobId}/summary";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSummaryInfoV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSummaryInfoV1Model>;
        }));
    }

    protected processGetSummaryByID(response: HttpResponseBase): Observable<JobSummaryInfoV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSummaryInfoV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: JobInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/jobs/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/jobs/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLifeCycle(model: JobLifeCycleUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/jobs/UpdateLifeCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLifeCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLifeCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateLifeCycle(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatus(model: JobStatusUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/jobs/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateActive(model: JobActiveUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/jobs/UpdateActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateActive(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllJobStatuses(): Observable<JobStatusV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/jobs/GetAllJobStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobStatusV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobStatusV1Model[]>;
        }));
    }

    protected processGetAllJobStatuses(response: HttpResponseBase): Observable<JobStatusV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobStatusV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobV1Model> {
        let url_ = this.baseUrl + "/api/JobOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobV1Model> {
        let url_ = this.baseUrl + "/api/JobOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobSubcontractorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: JobSubcontractorInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractors/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobSubcontractorId: number): Observable<JobMaterialV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractors/{jobSubcontractorId}";
        if (jobSubcontractorId === undefined || jobSubcontractorId === null)
            throw new Error("The parameter 'jobSubcontractorId' must be defined.");
        url_ = url_.replace("{jobSubcontractorId}", encodeURIComponent("" + jobSubcontractorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobMaterialV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobMaterialV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobMaterialV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobMaterialV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalAmountByJobId(jobSubcontractorId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractors/{jobSubcontractorId}/total-amount";
        if (jobSubcontractorId === undefined || jobSubcontractorId === null)
            throw new Error("The parameter 'jobSubcontractorId' must be defined.");
        url_ = url_.replace("{jobSubcontractorId}", encodeURIComponent("" + jobSubcontractorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalAmountByJobId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobSubcontractorUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractors/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobSubcontractorODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model> {
        let url_ = this.baseUrl + "/api/JobSubcontractorOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobSubcontractorV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model> {
        let url_ = this.baseUrl + "/api/JobSubcontractorOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobSubcontractorV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobSubcontractorV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobMaterialClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: JobMaterialInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-materials/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobMaterialId: number): Observable<JobMaterialV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-materials/{jobMaterialId}";
        if (jobMaterialId === undefined || jobMaterialId === null)
            throw new Error("The parameter 'jobMaterialId' must be defined.");
        url_ = url_.replace("{jobMaterialId}", encodeURIComponent("" + jobMaterialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobMaterialV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobMaterialV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobMaterialV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobMaterialV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalAmountByJobId(jobMaterialId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/job-materials/{jobMaterialId}/total-amount";
        if (jobMaterialId === undefined || jobMaterialId === null)
            throw new Error("The parameter 'jobMaterialId' must be defined.");
        url_ = url_.replace("{jobMaterialId}", encodeURIComponent("" + jobMaterialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalAmountByJobId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobMaterialUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-materials/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobMaterialODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobMaterialV1Model> {
        let url_ = this.baseUrl + "/api/JobMaterialOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobMaterialV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobMaterialV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobMaterialV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobMaterialV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobMaterialV1Model> {
        let url_ = this.baseUrl + "/api/JobMaterialOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobMaterialV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobMaterialV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobMaterialV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobMaterialV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobMaterialCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<JobMaterialCategoryV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/job-material-categories/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobMaterialCategoryV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobMaterialCategoryV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<JobMaterialCategoryV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobMaterialCategoryV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: JobMaterialCategoryInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-material-categories/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobMaterialCategoryId: number): Observable<JobMaterialV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-material-categories/{jobMaterialCategoryId}";
        if (jobMaterialCategoryId === undefined || jobMaterialCategoryId === null)
            throw new Error("The parameter 'jobMaterialCategoryId' must be defined.");
        url_ = url_.replace("{jobMaterialCategoryId}", encodeURIComponent("" + jobMaterialCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobMaterialV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobMaterialV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobMaterialV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobMaterialV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobMaterialCategoryUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-material-categories/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<EmployeeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/employees/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmployeeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(employeeId: number): Observable<EmployeeV1Model> {
        let url_ = this.baseUrl + "/api/v1/employees/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<EmployeeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: EmployeeInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/employees/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: EmployeeUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/employees/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateEmployeeSkillLevelReport(model: EmployeeSkillLevelReportSearchV1Model): Observable<EmployeeReportV1Model> {
        let url_ = this.baseUrl + "/api/v1/employees/EmployeeSkillLevelReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmployeeSkillLevelReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmployeeSkillLevelReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeReportV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeReportV1Model>;
        }));
    }

    protected processGenerateEmployeeSkillLevelReport(response: HttpResponseBase): Observable<EmployeeReportV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeReportV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfEmployeeV1Model> {
        let url_ = this.baseUrl + "/api/EmployeeOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfEmployeeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfEmployeeV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfEmployeeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfEmployeeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfEmployeeV1Model> {
        let url_ = this.baseUrl + "/api/EmployeeOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfEmployeeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfEmployeeV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfEmployeeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfEmployeeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeSkillLevelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(employeeSkillLevelId: number): Observable<EmployeeSkillLevelV1Model> {
        let url_ = this.baseUrl + "/api/v1/employeeskilllevel/{employeeSkillLevelId}";
        if (employeeSkillLevelId === undefined || employeeSkillLevelId === null)
            throw new Error("The parameter 'employeeSkillLevelId' must be defined.");
        url_ = url_.replace("{employeeSkillLevelId}", encodeURIComponent("" + employeeSkillLevelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeSkillLevelV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeSkillLevelV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<EmployeeSkillLevelV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeSkillLevelV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: EmployeeSkillLevelInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/employeeskilllevel/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: EmployeeSkillLevelUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/employeeskilllevel/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(employeeSkillLevelId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/employeeskilllevel/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeSkillLevelId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeSkillLevelODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model> {
        let url_ = this.baseUrl + "/api/EmployeeSkillLevelOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model> {
        let url_ = this.baseUrl + "/api/EmployeeSkillLevelOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DevOpsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    logError(error: ErrorV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/DevOps/api/V1/DevOps/LogError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(error);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processLogError(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHelp(helpContentId: number): Observable<FieldLevelHelpV1Model> {
        let url_ = this.baseUrl + "/api/v1/DevOps/help/{helpContentId}";
        if (helpContentId === undefined || helpContentId === null)
            throw new Error("The parameter 'helpContentId' must be defined.");
        url_ = url_.replace("{helpContentId}", encodeURIComponent("" + helpContentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldLevelHelpV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldLevelHelpV1Model>;
        }));
    }

    protected processGetHelp(response: HttpResponseBase): Observable<FieldLevelHelpV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldLevelHelpV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TimesheetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTimesheet(model: TimesheetSearchV1Model): Observable<TimesheetV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/GetTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetV1Model>;
        }));
    }

    protected processGetTimesheet(response: HttpResponseBase): Observable<TimesheetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateCostReport(model: CostReportSearchV1Model): Observable<CostReportV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/costReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCostReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCostReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostReportV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostReportV1Model>;
        }));
    }

    protected processGenerateCostReport(response: HttpResponseBase): Observable<CostReportV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostReportV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateProductionTracker(year: number, startMonth: number, endMonth: number): Observable<CostReportV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/productionTracker/{year}/{startMonth}/{endMonth}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (startMonth === undefined || startMonth === null)
            throw new Error("The parameter 'startMonth' must be defined.");
        url_ = url_.replace("{startMonth}", encodeURIComponent("" + startMonth));
        if (endMonth === undefined || endMonth === null)
            throw new Error("The parameter 'endMonth' must be defined.");
        url_ = url_.replace("{endMonth}", encodeURIComponent("" + endMonth));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateProductionTracker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateProductionTracker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostReportV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostReportV1Model>;
        }));
    }

    protected processGenerateProductionTracker(response: HttpResponseBase): Observable<CostReportV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostReportV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editTimesheet(model: TimesheetEditV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/EditTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processEditTimesheet(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    newTimesheet(model: TimesheetNewV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/NewTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processNewTimesheet(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveChanges(weekEnd: Date, json: any): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/{weekEnd}/save";
        if (weekEnd === undefined || weekEnd === null)
            throw new Error("The parameter 'weekEnd' must be defined.");
        url_ = url_.replace("{weekEnd}", encodeURIComponent(weekEnd ? "" + weekEnd.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(json);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processSaveChanges(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveTimesheet(weekEnd: Date, json: any): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/{weekEnd}/approve";
        if (weekEnd === undefined || weekEnd === null)
            throw new Error("The parameter 'weekEnd' must be defined.");
        url_ = url_.replace("{weekEnd}", encodeURIComponent(weekEnd ? "" + weekEnd.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(json);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processApproveTimesheet(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveChanges2(weekEnd: Date, models: JobLaborInsertV1Model[]): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/{weekEnd}/save2";
        if (weekEnd === undefined || weekEnd === null)
            throw new Error("The parameter 'weekEnd' must be defined.");
        url_ = url_.replace("{weekEnd}", encodeURIComponent(weekEnd ? "" + weekEnd.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveChanges2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveChanges2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processSaveChanges2(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveTimesheet2(weekEnd: Date, models: JobLaborInsertV1Model[]): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/{weekEnd}/approve2";
        if (weekEnd === undefined || weekEnd === null)
            throw new Error("The parameter 'weekEnd' must be defined.");
        url_ = url_.replace("{weekEnd}", encodeURIComponent(weekEnd ? "" + weekEnd.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveTimesheet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveTimesheet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processApproveTimesheet2(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unapproveTimesheet(weekEnd: Date): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/timesheet/{weekEnd}/unapprove";
        if (weekEnd === undefined || weekEnd === null)
            throw new Error("The parameter 'weekEnd' must be defined.");
        url_ = url_.replace("{weekEnd}", encodeURIComponent(weekEnd ? "" + weekEnd.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnapproveTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnapproveTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processUnapproveTimesheet(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SkillLevelCostClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<SkillLevelCostV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/skill-level-cost/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillLevelCostV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillLevelCostV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SkillLevelCostV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SkillLevelCostV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLastEnteredSkillLevelCost(skillLevelId: number): Observable<SkillLevelCostV1Model> {
        let url_ = this.baseUrl + "/api/v1/skill-level-cost/GetLastEnteredSkillLevelCost/{skillLevelId}";
        if (skillLevelId === undefined || skillLevelId === null)
            throw new Error("The parameter 'skillLevelId' must be defined.");
        url_ = url_.replace("{skillLevelId}", encodeURIComponent("" + skillLevelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastEnteredSkillLevelCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastEnteredSkillLevelCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillLevelCostV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillLevelCostV1Model>;
        }));
    }

    protected processGetLastEnteredSkillLevelCost(response: HttpResponseBase): Observable<SkillLevelCostV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillLevelCostV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(skillLevelCostId: number | undefined, skillLevelId: string): Observable<SkillLevelCostV1Model> {
        let url_ = this.baseUrl + "/api/v1/skill-level-cost/{skillLevelId}?";
        if (skillLevelId === undefined || skillLevelId === null)
            throw new Error("The parameter 'skillLevelId' must be defined.");
        url_ = url_.replace("{skillLevelId}", encodeURIComponent("" + skillLevelId));
        if (skillLevelCostId === null)
            throw new Error("The parameter 'skillLevelCostId' cannot be null.");
        else if (skillLevelCostId !== undefined)
            url_ += "skillLevelCostId=" + encodeURIComponent("" + skillLevelCostId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillLevelCostV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillLevelCostV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<SkillLevelCostV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillLevelCostV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: SkillLevelCostInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/skill-level-cost/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: SkillLevelCostUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/skill-level-cost/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobSubcontractorCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<JobSubcontractorCategoryV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-categories/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSubcontractorCategoryV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSubcontractorCategoryV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<JobSubcontractorCategoryV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobSubcontractorCategoryV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: JobSubcontractorCategoryInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-categories/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobSubcontractorCategoryId: number): Observable<JobSubcontractorCategoryV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-categories/{jobSubcontractorCategoryId}";
        if (jobSubcontractorCategoryId === undefined || jobSubcontractorCategoryId === null)
            throw new Error("The parameter 'jobSubcontractorCategoryId' must be defined.");
        url_ = url_.replace("{jobSubcontractorCategoryId}", encodeURIComponent("" + jobSubcontractorCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSubcontractorCategoryV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSubcontractorCategoryV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobSubcontractorCategoryV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSubcontractorCategoryV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobSubcontractorCategoryUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-categories/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobSubcontractorCategoryODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model> {
        let url_ = this.baseUrl + "/api/JobSubcontractorCategoryOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model> {
        let url_ = this.baseUrl + "/api/JobSubcontractorCategoryOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobSubcontractorBudgetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: JobSubcontractorBudgetInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-budget/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobSubcontractorBudgetId: number): Observable<JobSubcontractorBudgetV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-budget/{jobSubcontractorBudgetId}";
        if (jobSubcontractorBudgetId === undefined || jobSubcontractorBudgetId === null)
            throw new Error("The parameter 'jobSubcontractorBudgetId' must be defined.");
        url_ = url_.replace("{jobSubcontractorBudgetId}", encodeURIComponent("" + jobSubcontractorBudgetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSubcontractorBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSubcontractorBudgetV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobSubcontractorBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSubcontractorBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalAmountByJobId(jobRequestId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-budget/{jobRequestId}/total-amount";
        if (jobRequestId === undefined || jobRequestId === null)
            throw new Error("The parameter 'jobRequestId' must be defined.");
        url_ = url_.replace("{jobRequestId}", encodeURIComponent("" + jobRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalAmountByJobId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobSubcontractorBudgetUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-budget/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(jobSubcontractorBudgetId: number): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-subcontractor-budget/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobSubcontractorBudgetId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobSubcontractorBudgetODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model> {
        let url_ = this.baseUrl + "/api/JobSubcontractorBudgetOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model> {
        let url_ = this.baseUrl + "/api/JobSubcontractorBudgetOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobMaterialCategoryODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model> {
        let url_ = this.baseUrl + "/api/JobMaterialCategoryOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobMaterialCategoryV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model> {
        let url_ = this.baseUrl + "/api/JobMaterialCategoryOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobMaterialCategoryV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobMaterialCategoryV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobMaterialBudgetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: JobMaterialBudgetInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-material-budget/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobMaterialBudgetId: number): Observable<JobMaterialBudgetV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-material-budget/{jobMaterialBudgetId}";
        if (jobMaterialBudgetId === undefined || jobMaterialBudgetId === null)
            throw new Error("The parameter 'jobMaterialBudgetId' must be defined.");
        url_ = url_.replace("{jobMaterialBudgetId}", encodeURIComponent("" + jobMaterialBudgetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobMaterialBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobMaterialBudgetV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobMaterialBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobMaterialBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalAmountByJobId(jobRequestId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/job-material-budget/{jobRequestId}/total-amount";
        if (jobRequestId === undefined || jobRequestId === null)
            throw new Error("The parameter 'jobRequestId' must be defined.");
        url_ = url_.replace("{jobRequestId}", encodeURIComponent("" + jobRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalAmountByJobId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobMaterialBudgetUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-material-budget/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(jobMaterialBudgetId: number): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-material-budget/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobMaterialBudgetId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobMaterialBudgetODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model> {
        let url_ = this.baseUrl + "/api/JobMaterialBudgetOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobMaterialBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model> {
        let url_ = this.baseUrl + "/api/JobMaterialBudgetOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobMaterialBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobMaterialBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobLaborBudgetODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model> {
        let url_ = this.baseUrl + "/api/JobLaborBudgetOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobLaborBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model> {
        let url_ = this.baseUrl + "/api/JobLaborBudgetOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobLaborBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobLaborBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobLaborClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: JobLaborInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-labor/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(jobLaborId: number): Observable<JobLaborV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-labor/{jobLaborId}";
        if (jobLaborId === undefined || jobLaborId === null)
            throw new Error("The parameter 'jobLaborId' must be defined.");
        url_ = url_.replace("{jobLaborId}", encodeURIComponent("" + jobLaborId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLaborV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLaborV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobLaborV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLaborV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalAmountByJobId(jobLaborId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/job-labor/{jobLaborId}/total-amount";
        if (jobLaborId === undefined || jobLaborId === null)
            throw new Error("The parameter 'jobLaborId' must be defined.");
        url_ = url_.replace("{jobLaborId}", encodeURIComponent("" + jobLaborId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalAmountByJobId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobLaborUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-labor/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobLaborGroupedODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model> {
        let url_ = this.baseUrl + "/api/JobLaborGroupedOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobLaborGroupedV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model> {
        let url_ = this.baseUrl + "/api/JobLaborGroupedOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobLaborGroupedV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobLaborGroupedV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobLaborODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobLaborV1Model> {
        let url_ = this.baseUrl + "/api/JobLaborOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobLaborV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobLaborV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobLaborV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobLaborV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfJobLaborV1Model> {
        let url_ = this.baseUrl + "/api/JobLaborOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfJobLaborV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfJobLaborV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfJobLaborV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfJobLaborV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobLaborBudgetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByID(jobLaborBudgetId: number): Observable<JobLaborBudgetV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-labor-budget/{jobLaborBudgetId}";
        if (jobLaborBudgetId === undefined || jobLaborBudgetId === null)
            throw new Error("The parameter 'jobLaborBudgetId' must be defined.");
        url_ = url_.replace("{jobLaborBudgetId}", encodeURIComponent("" + jobLaborBudgetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLaborBudgetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLaborBudgetV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<JobLaborBudgetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLaborBudgetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: JobLaborBudgetInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-labor-budget/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: JobLaborBudgetUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-labor-budget/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(jobLaborBudgetId: number): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/job-labor-budget/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobLaborBudgetId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalAmountByJobId(jobLaborId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/job-labor-budget/{jobLaborId}/total-amount";
        if (jobLaborId === undefined || jobLaborId === null)
            throw new Error("The parameter 'jobLaborId' must be defined.");
        url_ = url_.replace("{jobLaborId}", encodeURIComponent("" + jobLaborId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmountByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmountByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalAmountByJobId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GridClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getGridColumns(modelName: string): Observable<GridColumnV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/grid/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridColumnV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridColumnV1Model[]>;
        }));
    }

    protected processGetGridColumns(response: HttpResponseBase): Observable<GridColumnV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GridColumnV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CostCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByID(costCodeId: number): Observable<CostCodeV1Model> {
        let url_ = this.baseUrl + "/api/v1/costCodes/GetById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(costCodeId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCodeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCodeV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<CostCodeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostCodeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CostCodeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/costCodes/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCodeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCodeV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CostCodeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CostCodeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: CostCodeSearchV1Model): Observable<CostCodeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/costCodes/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCodeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCodeV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<CostCodeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CostCodeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: CostCodeInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/costCodes/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: CostCodeUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/costCodes/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(costCodeId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/costCodes/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(costCodeId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CostCodeODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfCostCodeV1Model> {
        let url_ = this.baseUrl + "/api/CostCodeOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfCostCodeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfCostCodeV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfCostCodeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfCostCodeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfCostCodeV1Model> {
        let url_ = this.baseUrl + "/api/CostCodeOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfCostCodeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfCostCodeV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfCostCodeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfCostCodeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AuthSecContext implements IAuthSecContext {
    context?: SecurityContextV1Model | null;
    isAuthenticated?: boolean;
    token?: string | null;
    loginError?: boolean;
    loginErrorMessage?: string | null;
    expires?: Date;
    isExpired?: boolean;
    mfastatus?: MFAStatus;

    constructor(data?: IAuthSecContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? SecurityContextV1Model.fromJS(_data["context"]) : <any>null;
            this.isAuthenticated = _data["isAuthenticated"] !== undefined ? _data["isAuthenticated"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.loginError = _data["loginError"] !== undefined ? _data["loginError"] : <any>null;
            this.loginErrorMessage = _data["loginErrorMessage"] !== undefined ? _data["loginErrorMessage"] : <any>null;
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>null;
            this.isExpired = _data["isExpired"] !== undefined ? _data["isExpired"] : <any>null;
            this.mfastatus = _data["mfastatus"] !== undefined ? _data["mfastatus"] : <any>null;
        }
    }

    static fromJS(data: any): AuthSecContext {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSecContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>null;
        data["isAuthenticated"] = this.isAuthenticated !== undefined ? this.isAuthenticated : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["loginError"] = this.loginError !== undefined ? this.loginError : <any>null;
        data["loginErrorMessage"] = this.loginErrorMessage !== undefined ? this.loginErrorMessage : <any>null;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>null;
        data["isExpired"] = this.isExpired !== undefined ? this.isExpired : <any>null;
        data["mfastatus"] = this.mfastatus !== undefined ? this.mfastatus : <any>null;
        return data;
    }
}

export interface IAuthSecContext {
    context?: SecurityContextV1Model | null;
    isAuthenticated?: boolean;
    token?: string | null;
    loginError?: boolean;
    loginErrorMessage?: string | null;
    expires?: Date;
    isExpired?: boolean;
    mfastatus?: MFAStatus;
}

export class SecurityContextV1Model implements ISecurityContextV1Model {
    user?: UserSecV1Model | null;

    constructor(data?: ISecurityContextV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserSecV1Model.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): SecurityContextV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityContextV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }
}

export interface ISecurityContextV1Model {
    user?: UserSecV1Model | null;
}

export class UserSecV1Model implements IUserSecV1Model {
    currentUserId?: number;
    currentUserIdForAudit?: number;
    currentAccessGuid?: string | null;
    name?: string | null;
    email?: string | null;
    permissions?: APIPermissionModel[] | null;

    constructor(data?: IUserSecV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentUserId = _data["currentUserId"] !== undefined ? _data["currentUserId"] : <any>null;
            this.currentUserIdForAudit = _data["currentUserIdForAudit"] !== undefined ? _data["currentUserIdForAudit"] : <any>null;
            this.currentAccessGuid = _data["currentAccessGuid"] !== undefined ? _data["currentAccessGuid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(APIPermissionModel.fromJS(item));
            }
            else {
                this.permissions = <any>null;
            }
        }
    }

    static fromJS(data: any): UserSecV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserSecV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUserId"] = this.currentUserId !== undefined ? this.currentUserId : <any>null;
        data["currentUserIdForAudit"] = this.currentUserIdForAudit !== undefined ? this.currentUserIdForAudit : <any>null;
        data["currentAccessGuid"] = this.currentAccessGuid !== undefined ? this.currentAccessGuid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserSecV1Model {
    currentUserId?: number;
    currentUserIdForAudit?: number;
    currentAccessGuid?: string | null;
    name?: string | null;
    email?: string | null;
    permissions?: APIPermissionModel[] | null;
}

export class APIPermissionModel implements IAPIPermissionModel {
    apiPermissionId?: number;
    apiPermission?: string | null;

    constructor(data?: IAPIPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiPermissionId = _data["apiPermissionId"] !== undefined ? _data["apiPermissionId"] : <any>null;
            this.apiPermission = _data["apiPermission"] !== undefined ? _data["apiPermission"] : <any>null;
        }
    }

    static fromJS(data: any): APIPermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new APIPermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiPermissionId"] = this.apiPermissionId !== undefined ? this.apiPermissionId : <any>null;
        data["apiPermission"] = this.apiPermission !== undefined ? this.apiPermission : <any>null;
        return data;
    }
}

export interface IAPIPermissionModel {
    apiPermissionId?: number;
    apiPermission?: string | null;
}

export enum MFAStatus {
    SetupRequired = 1,
    NeedsAuthenticated = 2,
    Authenticated = 3,
}

export class AuthParam implements IAuthParam {
    clientid?: string | null;
    clientsecret?: string | null;
    username?: string | null;
    password?: string | null;
    scope?: string | null;

    constructor(data?: IAuthParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientid = _data["clientid"] !== undefined ? _data["clientid"] : <any>null;
            this.clientsecret = _data["clientsecret"] !== undefined ? _data["clientsecret"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.scope = _data["scope"] !== undefined ? _data["scope"] : <any>null;
        }
    }

    static fromJS(data: any): AuthParam {
        data = typeof data === 'object' ? data : {};
        let result = new AuthParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientid"] = this.clientid !== undefined ? this.clientid : <any>null;
        data["clientsecret"] = this.clientsecret !== undefined ? this.clientsecret : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["scope"] = this.scope !== undefined ? this.scope : <any>null;
        return data;
    }
}

export interface IAuthParam {
    clientid?: string | null;
    clientsecret?: string | null;
    username?: string | null;
    password?: string | null;
    scope?: string | null;
}

export class AuthMFASetup implements IAuthMFASetup {
    secret?: string | null;
    code?: string | null;

    constructor(data?: IAuthMFASetup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secret = _data["secret"] !== undefined ? _data["secret"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): AuthMFASetup {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMFASetup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secret"] = this.secret !== undefined ? this.secret : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data;
    }
}

export interface IAuthMFASetup {
    secret?: string | null;
    code?: string | null;
}

export class AuthSecContextInt implements IAuthSecContextInt {
    context?: AuthSecContext | null;

    constructor(data?: IAuthSecContextInt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? AuthSecContext.fromJS(_data["context"]) : <any>null;
        }
    }

    static fromJS(data: any): AuthSecContextInt {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSecContextInt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>null;
        return data;
    }
}

export interface IAuthSecContextInt {
    context?: AuthSecContext | null;
}

export class RoleV1Model implements IRoleV1Model {
    roleId?: number;
    role?: string | null;
    permissionCount?: number | null;

    constructor(data?: IRoleV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.permissionCount = _data["permissionCount"] !== undefined ? _data["permissionCount"] : <any>null;
        }
    }

    static fromJS(data: any): RoleV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new RoleV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["permissionCount"] = this.permissionCount !== undefined ? this.permissionCount : <any>null;
        return data;
    }
}

export interface IRoleV1Model {
    roleId?: number;
    role?: string | null;
    permissionCount?: number | null;
}

export class UserUpdateV1Model implements IUserUpdateV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    roleId?: number | null;

    constructor(data?: IUserUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : <any>null;
        }
    }

    static fromJS(data: any): UserUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : <any>null;
        return data;
    }
}

export interface IUserUpdateV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    roleId?: number | null;
}

export class UpdateResponseV1Model implements IUpdateResponseV1Model {
    totalRowsUpdated?: number;

    constructor(data?: IUpdateResponseV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRowsUpdated = _data["totalRowsUpdated"] !== undefined ? _data["totalRowsUpdated"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateResponseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponseV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRowsUpdated"] = this.totalRowsUpdated !== undefined ? this.totalRowsUpdated : <any>null;
        return data;
    }
}

export interface IUpdateResponseV1Model {
    totalRowsUpdated?: number;
}

export class ResetPasswordV1Model implements IResetPasswordV1Model {
    email?: string | null;
    password?: string | null;
    code?: string | null;

    constructor(data?: IResetPasswordV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data;
    }
}

export interface IResetPasswordV1Model {
    email?: string | null;
    password?: string | null;
    code?: string | null;
}

export class UserV1Model implements IUserV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    name?: string | null;
    jobTitle?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number | null;
    notes?: string | null;
    isActive?: boolean;
    roleId?: number | null;
    lastLogin?: Date | null;
    resetCode?: string | null;
    resetDate?: Date | null;

    constructor(data?: IUserV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : <any>null;
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>null;
            this.resetCode = _data["resetCode"] !== undefined ? _data["resetCode"] : <any>null;
            this.resetDate = _data["resetDate"] ? new Date(_data["resetDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : <any>null;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>null;
        data["resetCode"] = this.resetCode !== undefined ? this.resetCode : <any>null;
        data["resetDate"] = this.resetDate ? this.resetDate.toISOString() : <any>null;
        return data;
    }
}

export interface IUserV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    name?: string | null;
    jobTitle?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number | null;
    notes?: string | null;
    isActive?: boolean;
    roleId?: number | null;
    lastLogin?: Date | null;
    resetCode?: string | null;
    resetDate?: Date | null;
}

export class PageableListV1ModelOfUserV1Model implements IPageableListV1ModelOfUserV1Model {
    itemList?: UserV1Model[] | null;
    totalCount?: number;

    constructor(data?: IPageableListV1ModelOfUserV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itemList"])) {
                this.itemList = [] as any;
                for (let item of _data["itemList"])
                    this.itemList!.push(UserV1Model.fromJS(item));
            }
            else {
                this.itemList = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PageableListV1ModelOfUserV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new PageableListV1ModelOfUserV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemList)) {
            data["itemList"] = [];
            for (let item of this.itemList)
                data["itemList"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPageableListV1ModelOfUserV1Model {
    itemList?: UserV1Model[] | null;
    totalCount?: number;
}

export class BaseSearchV1 implements IBaseSearchV1 {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | null;
    sortDirection?: string | null;

    constructor(data?: IBaseSearchV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.sortField = _data["sortField"] !== undefined ? _data["sortField"] : <any>null;
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : <any>null;
        }
    }

    static fromJS(data: any): BaseSearchV1 {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSearchV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["sortField"] = this.sortField !== undefined ? this.sortField : <any>null;
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        return data;
    }
}

export interface IBaseSearchV1 {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | null;
    sortDirection?: string | null;
}

export class UserSearchV1Model extends BaseSearchV1 implements IUserSearchV1Model {
    name?: string | null;
    email?: string | null;
    isActive?: boolean | null;

    constructor(data?: IUserSearchV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static override fromJS(data: any): UserSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSearchV1Model extends IBaseSearchV1 {
    name?: string | null;
    email?: string | null;
    isActive?: boolean | null;
}

export class CommonResponseV1Model implements ICommonResponseV1Model {
    success?: boolean;
    message?: string | null;

    constructor(data?: ICommonResponseV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): CommonResponseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CommonResponseV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface ICommonResponseV1Model {
    success?: boolean;
    message?: string | null;
}

export class InsertResponseV1Model extends CommonResponseV1Model implements IInsertResponseV1Model {
    identityId?: number;
    identityIds?: number[] | null;

    constructor(data?: IInsertResponseV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identityId = _data["identityId"] !== undefined ? _data["identityId"] : <any>null;
            if (Array.isArray(_data["identityIds"])) {
                this.identityIds = [] as any;
                for (let item of _data["identityIds"])
                    this.identityIds!.push(item);
            }
            else {
                this.identityIds = <any>null;
            }
        }
    }

    static override fromJS(data: any): InsertResponseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new InsertResponseV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId !== undefined ? this.identityId : <any>null;
        if (Array.isArray(this.identityIds)) {
            data["identityIds"] = [];
            for (let item of this.identityIds)
                data["identityIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInsertResponseV1Model extends ICommonResponseV1Model {
    identityId?: number;
    identityIds?: number[] | null;
}

export class UserInsertV1Model implements IUserInsertV1Model {
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    password?: string | null;
    roleId?: number | null;

    constructor(data?: IUserInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : <any>null;
        }
    }

    static fromJS(data: any): UserInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : <any>null;
        return data;
    }
}

export interface IUserInsertV1Model {
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    password?: string | null;
    roleId?: number | null;
}

export class UserSettingV1Model implements IUserSettingV1Model {
    settingId?: number | null;
    userId?: number;
    settingKey?: string | null;
    settingValue?: string | null;
    lastModifiedById?: number | null;
    lastModifiedDate?: Date | null;

    constructor(data?: IUserSettingV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingId = _data["settingId"] !== undefined ? _data["settingId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.settingKey = _data["settingKey"] !== undefined ? _data["settingKey"] : <any>null;
            this.settingValue = _data["settingValue"] !== undefined ? _data["settingValue"] : <any>null;
            this.lastModifiedById = _data["lastModifiedById"] !== undefined ? _data["lastModifiedById"] : <any>null;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserSettingV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingId"] = this.settingId !== undefined ? this.settingId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["settingKey"] = this.settingKey !== undefined ? this.settingKey : <any>null;
        data["settingValue"] = this.settingValue !== undefined ? this.settingValue : <any>null;
        data["lastModifiedById"] = this.lastModifiedById !== undefined ? this.lastModifiedById : <any>null;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IUserSettingV1Model {
    settingId?: number | null;
    userId?: number;
    settingKey?: string | null;
    settingValue?: string | null;
    lastModifiedById?: number | null;
    lastModifiedDate?: Date | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfUserV1Model implements IODataValueOfIEnumerableOfUserV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: UserV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfUserV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(UserV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfUserV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfUserV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfUserV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: UserV1Model[] | null;
}

export class SkillLevelV1Model implements ISkillLevelV1Model {
    skillLevelId?: number;
    skillLevel?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;

    constructor(data?: ISkillLevelV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SkillLevelV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SkillLevelV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISkillLevelV1Model {
    skillLevelId?: number;
    skillLevel?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
}

export class SkillLevelInsertV1Model implements ISkillLevelInsertV1Model {
    skillLevel?: string | null;
    isActive?: boolean;

    constructor(data?: ISkillLevelInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SkillLevelInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SkillLevelInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISkillLevelInsertV1Model {
    skillLevel?: string | null;
    isActive?: boolean;
}

export class SkillLevelUpdateV1Model implements ISkillLevelUpdateV1Model {
    skillLevelId?: number;
    skillLevel?: string | null;
    isActive?: boolean;

    constructor(data?: ISkillLevelUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SkillLevelUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SkillLevelUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISkillLevelUpdateV1Model {
    skillLevelId?: number;
    skillLevel?: string | null;
    isActive?: boolean;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfSkillLevelV1Model implements IODataValueOfIEnumerableOfSkillLevelV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: SkillLevelV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfSkillLevelV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(SkillLevelV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfSkillLevelV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfSkillLevelV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfSkillLevelV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: SkillLevelV1Model[] | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfSkillLevelCostV1Model implements IODataValueOfIEnumerableOfSkillLevelCostV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: SkillLevelCostV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfSkillLevelCostV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(SkillLevelCostV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfSkillLevelCostV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfSkillLevelCostV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfSkillLevelCostV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: SkillLevelCostV1Model[] | null;
}

export class SkillLevelCostV1Model implements ISkillLevelCostV1Model {
    skillLevelCostId?: number;
    skillLevelId?: number;
    regularCost?: number;
    overtimeCost?: number;
    timeOffCost?: number;
    startDate?: Date;
    endDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;

    constructor(data?: ISkillLevelCostV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillLevelCostId = _data["skillLevelCostId"] !== undefined ? _data["skillLevelCostId"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.regularCost = _data["regularCost"] !== undefined ? _data["regularCost"] : <any>null;
            this.overtimeCost = _data["overtimeCost"] !== undefined ? _data["overtimeCost"] : <any>null;
            this.timeOffCost = _data["timeOffCost"] !== undefined ? _data["timeOffCost"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SkillLevelCostV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SkillLevelCostV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillLevelCostId"] = this.skillLevelCostId !== undefined ? this.skillLevelCostId : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["regularCost"] = this.regularCost !== undefined ? this.regularCost : <any>null;
        data["overtimeCost"] = this.overtimeCost !== undefined ? this.overtimeCost : <any>null;
        data["timeOffCost"] = this.timeOffCost !== undefined ? this.timeOffCost : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISkillLevelCostV1Model {
    skillLevelCostId?: number;
    skillLevelId?: number;
    regularCost?: number;
    overtimeCost?: number;
    timeOffCost?: number;
    startDate?: Date;
    endDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
}

export class JobWorkflowInsertV1Model implements IJobWorkflowInsertV1Model {
    workflowItemId?: number;
    jobId?: number;

    constructor(data?: IJobWorkflowInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowItemId = _data["workflowItemId"] !== undefined ? _data["workflowItemId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
        }
    }

    static fromJS(data: any): JobWorkflowInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobWorkflowInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowItemId"] = this.workflowItemId !== undefined ? this.workflowItemId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        return data;
    }
}

export interface IJobWorkflowInsertV1Model {
    workflowItemId?: number;
    jobId?: number;
}

export class JobWorkflowV1Model implements IJobWorkflowV1Model {
    workflowItemId?: number;
    dateCompleted?: Date;
    jobId?: number;

    constructor(data?: IJobWorkflowV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowItemId = _data["workflowItemId"] !== undefined ? _data["workflowItemId"] : <any>null;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
        }
    }

    static fromJS(data: any): JobWorkflowV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobWorkflowV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowItemId"] = this.workflowItemId !== undefined ? this.workflowItemId : <any>null;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        return data;
    }
}

export interface IJobWorkflowV1Model {
    workflowItemId?: number;
    dateCompleted?: Date;
    jobId?: number;
}

export class UncheckV1Model implements IUncheckV1Model {
    workflowItemId?: number;
    jobId?: number;

    constructor(data?: IUncheckV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowItemId = _data["workflowItemId"] !== undefined ? _data["workflowItemId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
        }
    }

    static fromJS(data: any): UncheckV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UncheckV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowItemId"] = this.workflowItemId !== undefined ? this.workflowItemId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        return data;
    }
}

export interface IUncheckV1Model {
    workflowItemId?: number;
    jobId?: number;
}

export class JobV1Model implements IJobV1Model {
    jobId?: number;
    jobNumber?: string | null;
    jobDescription?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    createdByUserName?: string | null;
    updatedDate?: Date;
    updatedByUserId?: number;
    updatedByUserName?: string | null;
    jobStatusId?: number;
    jobStatus?: string | null;
    customer?: string | null;
    project?: string | null;
    bidExpectedDate?: Date | null;
    bidEstimate?: number | null;
    bidExpectedProfit?: number | null;
    overheadRatio?: number | null;
    overheadAmount?: number | null;
    projectStartDate?: Date | null;
    projectCompletionDate?: Date | null;
    bidDueDate?: Date | null;
    bidSubmittedDate?: Date | null;
    totalBidAmount?: number | null;
    actualStartDate?: Date | null;
    projectedDuration?: number | null;
    rfqReceivedDate?: Date | null;
    isActive?: boolean;

    constructor(data?: IJobV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.jobDescription = _data["jobDescription"] !== undefined ? _data["jobDescription"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUserName = _data["createdByUserName"] !== undefined ? _data["createdByUserName"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUserName = _data["updatedByUserName"] !== undefined ? _data["updatedByUserName"] : <any>null;
            this.jobStatusId = _data["jobStatusId"] !== undefined ? _data["jobStatusId"] : <any>null;
            this.jobStatus = _data["jobStatus"] !== undefined ? _data["jobStatus"] : <any>null;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.bidExpectedDate = _data["bidExpectedDate"] ? new Date(_data["bidExpectedDate"].toString()) : <any>null;
            this.bidEstimate = _data["bidEstimate"] !== undefined ? _data["bidEstimate"] : <any>null;
            this.bidExpectedProfit = _data["bidExpectedProfit"] !== undefined ? _data["bidExpectedProfit"] : <any>null;
            this.overheadRatio = _data["overheadRatio"] !== undefined ? _data["overheadRatio"] : <any>null;
            this.overheadAmount = _data["overheadAmount"] !== undefined ? _data["overheadAmount"] : <any>null;
            this.projectStartDate = _data["projectStartDate"] ? new Date(_data["projectStartDate"].toString()) : <any>null;
            this.projectCompletionDate = _data["projectCompletionDate"] ? new Date(_data["projectCompletionDate"].toString()) : <any>null;
            this.bidDueDate = _data["bidDueDate"] ? new Date(_data["bidDueDate"].toString()) : <any>null;
            this.bidSubmittedDate = _data["bidSubmittedDate"] ? new Date(_data["bidSubmittedDate"].toString()) : <any>null;
            this.totalBidAmount = _data["totalBidAmount"] !== undefined ? _data["totalBidAmount"] : <any>null;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : <any>null;
            this.projectedDuration = _data["projectedDuration"] !== undefined ? _data["projectedDuration"] : <any>null;
            this.rfqReceivedDate = _data["rfqReceivedDate"] ? new Date(_data["rfqReceivedDate"].toString()) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["jobDescription"] = this.jobDescription !== undefined ? this.jobDescription : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUserName"] = this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUserName"] = this.updatedByUserName !== undefined ? this.updatedByUserName : <any>null;
        data["jobStatusId"] = this.jobStatusId !== undefined ? this.jobStatusId : <any>null;
        data["jobStatus"] = this.jobStatus !== undefined ? this.jobStatus : <any>null;
        data["customer"] = this.customer !== undefined ? this.customer : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["bidExpectedDate"] = this.bidExpectedDate ? this.bidExpectedDate.toISOString() : <any>null;
        data["bidEstimate"] = this.bidEstimate !== undefined ? this.bidEstimate : <any>null;
        data["bidExpectedProfit"] = this.bidExpectedProfit !== undefined ? this.bidExpectedProfit : <any>null;
        data["overheadRatio"] = this.overheadRatio !== undefined ? this.overheadRatio : <any>null;
        data["overheadAmount"] = this.overheadAmount !== undefined ? this.overheadAmount : <any>null;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toISOString() : <any>null;
        data["projectCompletionDate"] = this.projectCompletionDate ? this.projectCompletionDate.toISOString() : <any>null;
        data["bidDueDate"] = this.bidDueDate ? this.bidDueDate.toISOString() : <any>null;
        data["bidSubmittedDate"] = this.bidSubmittedDate ? this.bidSubmittedDate.toISOString() : <any>null;
        data["totalBidAmount"] = this.totalBidAmount !== undefined ? this.totalBidAmount : <any>null;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : <any>null;
        data["projectedDuration"] = this.projectedDuration !== undefined ? this.projectedDuration : <any>null;
        data["rfqReceivedDate"] = this.rfqReceivedDate ? this.rfqReceivedDate.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobV1Model {
    jobId?: number;
    jobNumber?: string | null;
    jobDescription?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    createdByUserName?: string | null;
    updatedDate?: Date;
    updatedByUserId?: number;
    updatedByUserName?: string | null;
    jobStatusId?: number;
    jobStatus?: string | null;
    customer?: string | null;
    project?: string | null;
    bidExpectedDate?: Date | null;
    bidEstimate?: number | null;
    bidExpectedProfit?: number | null;
    overheadRatio?: number | null;
    overheadAmount?: number | null;
    projectStartDate?: Date | null;
    projectCompletionDate?: Date | null;
    bidDueDate?: Date | null;
    bidSubmittedDate?: Date | null;
    totalBidAmount?: number | null;
    actualStartDate?: Date | null;
    projectedDuration?: number | null;
    rfqReceivedDate?: Date | null;
    isActive?: boolean;
}

export class JobSummaryInfoV1Model implements IJobSummaryInfoV1Model {
    budgetLaborCost?: number;
    budgetMaterialCost?: number;
    budgetSubcontractorCost?: number;
    laborCost?: number;
    materialCost?: number;
    subcontractorCost?: number;
    total?: number;

    constructor(data?: IJobSummaryInfoV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetLaborCost = _data["budgetLaborCost"] !== undefined ? _data["budgetLaborCost"] : <any>null;
            this.budgetMaterialCost = _data["budgetMaterialCost"] !== undefined ? _data["budgetMaterialCost"] : <any>null;
            this.budgetSubcontractorCost = _data["budgetSubcontractorCost"] !== undefined ? _data["budgetSubcontractorCost"] : <any>null;
            this.laborCost = _data["laborCost"] !== undefined ? _data["laborCost"] : <any>null;
            this.materialCost = _data["materialCost"] !== undefined ? _data["materialCost"] : <any>null;
            this.subcontractorCost = _data["subcontractorCost"] !== undefined ? _data["subcontractorCost"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): JobSummaryInfoV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSummaryInfoV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetLaborCost"] = this.budgetLaborCost !== undefined ? this.budgetLaborCost : <any>null;
        data["budgetMaterialCost"] = this.budgetMaterialCost !== undefined ? this.budgetMaterialCost : <any>null;
        data["budgetSubcontractorCost"] = this.budgetSubcontractorCost !== undefined ? this.budgetSubcontractorCost : <any>null;
        data["laborCost"] = this.laborCost !== undefined ? this.laborCost : <any>null;
        data["materialCost"] = this.materialCost !== undefined ? this.materialCost : <any>null;
        data["subcontractorCost"] = this.subcontractorCost !== undefined ? this.subcontractorCost : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        return data;
    }
}

export interface IJobSummaryInfoV1Model {
    budgetLaborCost?: number;
    budgetMaterialCost?: number;
    budgetSubcontractorCost?: number;
    laborCost?: number;
    materialCost?: number;
    subcontractorCost?: number;
    total?: number;
}

export class JobInsertV1Model implements IJobInsertV1Model {
    jobNumber?: string | null;
    jobDescription?: string | null;
    customer?: string | null;
    project?: string | null;
    bidDueDate?: Date | null;
    bidEstimate?: number | null;

    constructor(data?: IJobInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.jobDescription = _data["jobDescription"] !== undefined ? _data["jobDescription"] : <any>null;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.bidDueDate = _data["bidDueDate"] ? new Date(_data["bidDueDate"].toString()) : <any>null;
            this.bidEstimate = _data["bidEstimate"] !== undefined ? _data["bidEstimate"] : <any>null;
        }
    }

    static fromJS(data: any): JobInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["jobDescription"] = this.jobDescription !== undefined ? this.jobDescription : <any>null;
        data["customer"] = this.customer !== undefined ? this.customer : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["bidDueDate"] = this.bidDueDate ? this.bidDueDate.toISOString() : <any>null;
        data["bidEstimate"] = this.bidEstimate !== undefined ? this.bidEstimate : <any>null;
        return data;
    }
}

export interface IJobInsertV1Model {
    jobNumber?: string | null;
    jobDescription?: string | null;
    customer?: string | null;
    project?: string | null;
    bidDueDate?: Date | null;
    bidEstimate?: number | null;
}

export class JobUpdateV1Model implements IJobUpdateV1Model {
    jobId?: number;
    jobDescription?: string | null;
    jobNumber?: string | null;
    customer?: string | null;
    project?: string | null;
    bidDueDate?: Date | null;
    bidEstimate?: number | null;
    isActive?: boolean;
    jobStatusId?: number;

    constructor(data?: IJobUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobDescription = _data["jobDescription"] !== undefined ? _data["jobDescription"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.bidDueDate = _data["bidDueDate"] ? new Date(_data["bidDueDate"].toString()) : <any>null;
            this.bidEstimate = _data["bidEstimate"] !== undefined ? _data["bidEstimate"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.jobStatusId = _data["jobStatusId"] !== undefined ? _data["jobStatusId"] : <any>null;
        }
    }

    static fromJS(data: any): JobUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobDescription"] = this.jobDescription !== undefined ? this.jobDescription : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["customer"] = this.customer !== undefined ? this.customer : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["bidDueDate"] = this.bidDueDate ? this.bidDueDate.toISOString() : <any>null;
        data["bidEstimate"] = this.bidEstimate !== undefined ? this.bidEstimate : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["jobStatusId"] = this.jobStatusId !== undefined ? this.jobStatusId : <any>null;
        return data;
    }
}

export interface IJobUpdateV1Model {
    jobId?: number;
    jobDescription?: string | null;
    jobNumber?: string | null;
    customer?: string | null;
    project?: string | null;
    bidDueDate?: Date | null;
    bidEstimate?: number | null;
    isActive?: boolean;
    jobStatusId?: number;
}

export class JobLifeCycleUpdateV1Model implements IJobLifeCycleUpdateV1Model {
    jobId?: number;
    bidEstimate?: number | null;
    bidExpectedProfit?: number | null;
    overheadRatio?: number | null;
    overheadAmount?: number | null;
    projectStartDate?: Date | null;
    projectCompletionDate?: Date | null;
    bidDueDate?: Date | null;
    bidSubmittedDate?: Date | null;
    totalBidAmount?: number | null;
    actualStartDate?: Date | null;
    projectedDuration?: number | null;
    rfqReceivedDate?: Date | null;

    constructor(data?: IJobLifeCycleUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.bidEstimate = _data["bidEstimate"] !== undefined ? _data["bidEstimate"] : <any>null;
            this.bidExpectedProfit = _data["bidExpectedProfit"] !== undefined ? _data["bidExpectedProfit"] : <any>null;
            this.overheadRatio = _data["overheadRatio"] !== undefined ? _data["overheadRatio"] : <any>null;
            this.overheadAmount = _data["overheadAmount"] !== undefined ? _data["overheadAmount"] : <any>null;
            this.projectStartDate = _data["projectStartDate"] ? new Date(_data["projectStartDate"].toString()) : <any>null;
            this.projectCompletionDate = _data["projectCompletionDate"] ? new Date(_data["projectCompletionDate"].toString()) : <any>null;
            this.bidDueDate = _data["bidDueDate"] ? new Date(_data["bidDueDate"].toString()) : <any>null;
            this.bidSubmittedDate = _data["bidSubmittedDate"] ? new Date(_data["bidSubmittedDate"].toString()) : <any>null;
            this.totalBidAmount = _data["totalBidAmount"] !== undefined ? _data["totalBidAmount"] : <any>null;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : <any>null;
            this.projectedDuration = _data["projectedDuration"] !== undefined ? _data["projectedDuration"] : <any>null;
            this.rfqReceivedDate = _data["rfqReceivedDate"] ? new Date(_data["rfqReceivedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobLifeCycleUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLifeCycleUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["bidEstimate"] = this.bidEstimate !== undefined ? this.bidEstimate : <any>null;
        data["bidExpectedProfit"] = this.bidExpectedProfit !== undefined ? this.bidExpectedProfit : <any>null;
        data["overheadRatio"] = this.overheadRatio !== undefined ? this.overheadRatio : <any>null;
        data["overheadAmount"] = this.overheadAmount !== undefined ? this.overheadAmount : <any>null;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toISOString() : <any>null;
        data["projectCompletionDate"] = this.projectCompletionDate ? this.projectCompletionDate.toISOString() : <any>null;
        data["bidDueDate"] = this.bidDueDate ? this.bidDueDate.toISOString() : <any>null;
        data["bidSubmittedDate"] = this.bidSubmittedDate ? this.bidSubmittedDate.toISOString() : <any>null;
        data["totalBidAmount"] = this.totalBidAmount !== undefined ? this.totalBidAmount : <any>null;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : <any>null;
        data["projectedDuration"] = this.projectedDuration !== undefined ? this.projectedDuration : <any>null;
        data["rfqReceivedDate"] = this.rfqReceivedDate ? this.rfqReceivedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IJobLifeCycleUpdateV1Model {
    jobId?: number;
    bidEstimate?: number | null;
    bidExpectedProfit?: number | null;
    overheadRatio?: number | null;
    overheadAmount?: number | null;
    projectStartDate?: Date | null;
    projectCompletionDate?: Date | null;
    bidDueDate?: Date | null;
    bidSubmittedDate?: Date | null;
    totalBidAmount?: number | null;
    actualStartDate?: Date | null;
    projectedDuration?: number | null;
    rfqReceivedDate?: Date | null;
}

export class JobStatusUpdateV1Model implements IJobStatusUpdateV1Model {
    jobStatusId?: number;
    jobId?: number;

    constructor(data?: IJobStatusUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobStatusId = _data["jobStatusId"] !== undefined ? _data["jobStatusId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
        }
    }

    static fromJS(data: any): JobStatusUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobStatusUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobStatusId"] = this.jobStatusId !== undefined ? this.jobStatusId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        return data;
    }
}

export interface IJobStatusUpdateV1Model {
    jobStatusId?: number;
    jobId?: number;
}

export class JobActiveUpdateV1Model implements IJobActiveUpdateV1Model {
    isActive?: boolean;
    jobId?: number;

    constructor(data?: IJobActiveUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
        }
    }

    static fromJS(data: any): JobActiveUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobActiveUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        return data;
    }
}

export interface IJobActiveUpdateV1Model {
    isActive?: boolean;
    jobId?: number;
}

export class JobStatusV1Model implements IJobStatusV1Model {
    jobStatusId?: number;
    name?: string | null;

    constructor(data?: IJobStatusV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobStatusId = _data["jobStatusId"] !== undefined ? _data["jobStatusId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): JobStatusV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobStatusV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobStatusId"] = this.jobStatusId !== undefined ? this.jobStatusId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IJobStatusV1Model {
    jobStatusId?: number;
    name?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobV1Model implements IODataValueOfIEnumerableOfJobV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobV1Model[] | null;
}

export class JobSubcontractorInsertV1Model implements IJobSubcontractorInsertV1Model {
    jobId?: number;
    contractorName?: string | null;
    description?: string | null;
    jobSubcontractorCategoryId?: number;
    amount?: number;

    constructor(data?: IJobSubcontractorInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.contractorName = _data["contractorName"] !== undefined ? _data["contractorName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["contractorName"] = this.contractorName !== undefined ? this.contractorName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IJobSubcontractorInsertV1Model {
    jobId?: number;
    contractorName?: string | null;
    description?: string | null;
    jobSubcontractorCategoryId?: number;
    amount?: number;
}

export class JobMaterialV1Model implements IJobMaterialV1Model {
    jobMaterialId?: number;
    jobId?: number;
    jobNumber?: string | null;
    jobMaterialCategoryId?: number;
    category?: string | null;
    description?: string | null;
    amount?: number;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;

    constructor(data?: IJobMaterialV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialId = _data["jobMaterialId"] !== undefined ? _data["jobMaterialId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialId"] = this.jobMaterialId !== undefined ? this.jobMaterialId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobMaterialV1Model {
    jobMaterialId?: number;
    jobId?: number;
    jobNumber?: string | null;
    jobMaterialCategoryId?: number;
    category?: string | null;
    description?: string | null;
    amount?: number;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
}

export class JobSubcontractorUpdateV1Model implements IJobSubcontractorUpdateV1Model {
    jobSubcontractorId?: number;
    jobId?: number;
    contractorName?: string | null;
    jobSubcontractorCategoryId?: number;
    description?: string | null;
    amount?: number;

    constructor(data?: IJobSubcontractorUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSubcontractorId = _data["jobSubcontractorId"] !== undefined ? _data["jobSubcontractorId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.contractorName = _data["contractorName"] !== undefined ? _data["contractorName"] : <any>null;
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSubcontractorId"] = this.jobSubcontractorId !== undefined ? this.jobSubcontractorId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["contractorName"] = this.contractorName !== undefined ? this.contractorName : <any>null;
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IJobSubcontractorUpdateV1Model {
    jobSubcontractorId?: number;
    jobId?: number;
    contractorName?: string | null;
    jobSubcontractorCategoryId?: number;
    description?: string | null;
    amount?: number;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobSubcontractorV1Model implements IODataValueOfIEnumerableOfJobSubcontractorV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobSubcontractorV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobSubcontractorV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobSubcontractorV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobSubcontractorV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobSubcontractorV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobSubcontractorV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobSubcontractorV1Model[] | null;
}

export class JobSubcontractorV1Model implements IJobSubcontractorV1Model {
    jobSubcontractorId?: number;
    jobId?: number;
    jobNumber?: string | null;
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    contractorName?: string | null;
    description?: string | null;
    amount?: number;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;

    constructor(data?: IJobSubcontractorV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSubcontractorId = _data["jobSubcontractorId"] !== undefined ? _data["jobSubcontractorId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.contractorName = _data["contractorName"] !== undefined ? _data["contractorName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSubcontractorId"] = this.jobSubcontractorId !== undefined ? this.jobSubcontractorId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["contractorName"] = this.contractorName !== undefined ? this.contractorName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobSubcontractorV1Model {
    jobSubcontractorId?: number;
    jobId?: number;
    jobNumber?: string | null;
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    contractorName?: string | null;
    description?: string | null;
    amount?: number;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
}

export class JobMaterialInsertV1Model implements IJobMaterialInsertV1Model {
    jobId?: number;
    description?: string | null;
    jobMaterialCategoryId?: number;
    amount?: number;
    isActive?: boolean;

    constructor(data?: IJobMaterialInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobMaterialInsertV1Model {
    jobId?: number;
    description?: string | null;
    jobMaterialCategoryId?: number;
    amount?: number;
    isActive?: boolean;
}

export class JobMaterialUpdateV1Model implements IJobMaterialUpdateV1Model {
    jobMaterialId?: number;
    jobId?: number;
    description?: string | null;
    jobMaterialCategoryId?: number;
    amount?: number;
    isActive?: boolean;

    constructor(data?: IJobMaterialUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialId = _data["jobMaterialId"] !== undefined ? _data["jobMaterialId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialId"] = this.jobMaterialId !== undefined ? this.jobMaterialId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobMaterialUpdateV1Model {
    jobMaterialId?: number;
    jobId?: number;
    description?: string | null;
    jobMaterialCategoryId?: number;
    amount?: number;
    isActive?: boolean;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobMaterialV1Model implements IODataValueOfIEnumerableOfJobMaterialV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobMaterialV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobMaterialV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobMaterialV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobMaterialV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobMaterialV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobMaterialV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobMaterialV1Model[] | null;
}

export class JobMaterialCategoryV1Model implements IJobMaterialCategoryV1Model {
    jobMaterialCategoryId?: number;
    category?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;

    constructor(data?: IJobMaterialCategoryV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialCategoryV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialCategoryV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobMaterialCategoryV1Model {
    jobMaterialCategoryId?: number;
    category?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
}

export class JobMaterialCategoryInsertV1Model implements IJobMaterialCategoryInsertV1Model {
    category?: string | null;
    isActive?: boolean;

    constructor(data?: IJobMaterialCategoryInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialCategoryInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialCategoryInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobMaterialCategoryInsertV1Model {
    category?: string | null;
    isActive?: boolean;
}

export class JobMaterialCategoryUpdateV1Model implements IJobMaterialCategoryUpdateV1Model {
    jobMaterialCategoryId?: number;
    category?: string | null;
    isActive?: boolean;

    constructor(data?: IJobMaterialCategoryUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialCategoryUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialCategoryUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobMaterialCategoryUpdateV1Model {
    jobMaterialCategoryId?: number;
    category?: string | null;
    isActive?: boolean;
}

export class EmployeeV1Model implements IEmployeeV1Model {
    employeeId?: number;
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    skillLevelId?: number;
    skillLevel?: string | null;
    unionCode?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
    laborBurden?: number | null;

    constructor(data?: IEmployeeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            this.unionCode = _data["unionCode"] !== undefined ? _data["unionCode"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.laborBurden = _data["laborBurden"] !== undefined ? _data["laborBurden"] : <any>null;
        }
    }

    static fromJS(data: any): EmployeeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        data["unionCode"] = this.unionCode !== undefined ? this.unionCode : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["laborBurden"] = this.laborBurden !== undefined ? this.laborBurden : <any>null;
        return data;
    }
}

export interface IEmployeeV1Model {
    employeeId?: number;
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    skillLevelId?: number;
    skillLevel?: string | null;
    unionCode?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
    laborBurden?: number | null;
}

export class EmployeeInsertV1Model implements IEmployeeInsertV1Model {
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    unionCode?: string | null;
    isActive?: boolean;
    laborBurden?: number | null;

    constructor(data?: IEmployeeInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.unionCode = _data["unionCode"] !== undefined ? _data["unionCode"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.laborBurden = _data["laborBurden"] !== undefined ? _data["laborBurden"] : <any>null;
        }
    }

    static fromJS(data: any): EmployeeInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["unionCode"] = this.unionCode !== undefined ? this.unionCode : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["laborBurden"] = this.laborBurden !== undefined ? this.laborBurden : <any>null;
        return data;
    }
}

export interface IEmployeeInsertV1Model {
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    unionCode?: string | null;
    isActive?: boolean;
    laborBurden?: number | null;
}

export class EmployeeUpdateV1Model implements IEmployeeUpdateV1Model {
    employeeId?: number;
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    unionCode?: string | null;
    isActive?: boolean;
    laborBurden?: number | null;

    constructor(data?: IEmployeeUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.unionCode = _data["unionCode"] !== undefined ? _data["unionCode"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.laborBurden = _data["laborBurden"] !== undefined ? _data["laborBurden"] : <any>null;
        }
    }

    static fromJS(data: any): EmployeeUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["unionCode"] = this.unionCode !== undefined ? this.unionCode : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["laborBurden"] = this.laborBurden !== undefined ? this.laborBurden : <any>null;
        return data;
    }
}

export interface IEmployeeUpdateV1Model {
    employeeId?: number;
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    unionCode?: string | null;
    isActive?: boolean;
    laborBurden?: number | null;
}

export class EmployeeReportV1Model implements IEmployeeReportV1Model {
    fileName?: string | null;
    fileBase64?: string | null;
    contentType?: string | null;

    constructor(data?: IEmployeeReportV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
        }
    }

    static fromJS(data: any): EmployeeReportV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeReportV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        return data;
    }
}

export interface IEmployeeReportV1Model {
    fileName?: string | null;
    fileBase64?: string | null;
    contentType?: string | null;
}

export class EmployeeSkillLevelReportSearchV1Model implements IEmployeeSkillLevelReportSearchV1Model {
    startDate?: Date | null;
    endDate?: Date | null;

    constructor(data?: IEmployeeSkillLevelReportSearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EmployeeSkillLevelReportSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSkillLevelReportSearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }
}

export interface IEmployeeSkillLevelReportSearchV1Model {
    startDate?: Date | null;
    endDate?: Date | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfEmployeeV1Model implements IODataValueOfIEnumerableOfEmployeeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: EmployeeV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfEmployeeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(EmployeeV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfEmployeeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfEmployeeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfEmployeeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: EmployeeV1Model[] | null;
}

export class EmployeeSkillLevelV1Model implements IEmployeeSkillLevelV1Model {
    employeeSkillLevelId?: number;
    employeeID?: number;
    employeeName?: string | null;
    skillLevelID?: number;
    skillLevel?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;

    constructor(data?: IEmployeeSkillLevelV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeSkillLevelId = _data["employeeSkillLevelId"] !== undefined ? _data["employeeSkillLevelId"] : <any>null;
            this.employeeID = _data["employeeID"] !== undefined ? _data["employeeID"] : <any>null;
            this.employeeName = _data["employeeName"] !== undefined ? _data["employeeName"] : <any>null;
            this.skillLevelID = _data["skillLevelID"] !== undefined ? _data["skillLevelID"] : <any>null;
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EmployeeSkillLevelV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSkillLevelV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeSkillLevelId"] = this.employeeSkillLevelId !== undefined ? this.employeeSkillLevelId : <any>null;
        data["employeeID"] = this.employeeID !== undefined ? this.employeeID : <any>null;
        data["employeeName"] = this.employeeName !== undefined ? this.employeeName : <any>null;
        data["skillLevelID"] = this.skillLevelID !== undefined ? this.skillLevelID : <any>null;
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }
}

export interface IEmployeeSkillLevelV1Model {
    employeeSkillLevelId?: number;
    employeeID?: number;
    employeeName?: string | null;
    skillLevelID?: number;
    skillLevel?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
}

export class EmployeeSkillLevelInsertV1Model implements IEmployeeSkillLevelInsertV1Model {
    employeeId?: number;
    skillLevelId?: number;
    startDate?: Date;

    constructor(data?: IEmployeeSkillLevelInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EmployeeSkillLevelInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSkillLevelInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        return data;
    }
}

export interface IEmployeeSkillLevelInsertV1Model {
    employeeId?: number;
    skillLevelId?: number;
    startDate?: Date;
}

export class EmployeeSkillLevelUpdateV1Model implements IEmployeeSkillLevelUpdateV1Model {
    employeeSkillLevelId?: number;
    employeeId?: number;
    skillLevelId?: number;
    startDate?: Date | null;
    endDate?: Date | null;

    constructor(data?: IEmployeeSkillLevelUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeSkillLevelId = _data["employeeSkillLevelId"] !== undefined ? _data["employeeSkillLevelId"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EmployeeSkillLevelUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSkillLevelUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeSkillLevelId"] = this.employeeSkillLevelId !== undefined ? this.employeeSkillLevelId : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }
}

export interface IEmployeeSkillLevelUpdateV1Model {
    employeeSkillLevelId?: number;
    employeeId?: number;
    skillLevelId?: number;
    startDate?: Date | null;
    endDate?: Date | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model implements IODataValueOfIEnumerableOfEmployeeSkillLevelV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: EmployeeSkillLevelV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfEmployeeSkillLevelV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(EmployeeSkillLevelV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfEmployeeSkillLevelV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfEmployeeSkillLevelV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: EmployeeSkillLevelV1Model[] | null;
}

export class ErrorV1Model implements IErrorV1Model {
    requestUrl?: string | null;
    machineName?: string | null;
    eventTime?: Date;
    requestPath?: string | null;
    userHostAddress?: string | null;
    message?: string | null;
    exception?: string | null;
    exceptionCode?: string | null;
    exceptionMessage?: string | null;
    stackTrace?: string | null;
    sessionDump?: string | null;
    applicationName?: string | null;
    accountId?: number | null;
    userId?: number | null;

    constructor(data?: IErrorV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestUrl = _data["requestUrl"] !== undefined ? _data["requestUrl"] : <any>null;
            this.machineName = _data["machineName"] !== undefined ? _data["machineName"] : <any>null;
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>null;
            this.requestPath = _data["requestPath"] !== undefined ? _data["requestPath"] : <any>null;
            this.userHostAddress = _data["userHostAddress"] !== undefined ? _data["userHostAddress"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.exception = _data["exception"] !== undefined ? _data["exception"] : <any>null;
            this.exceptionCode = _data["exceptionCode"] !== undefined ? _data["exceptionCode"] : <any>null;
            this.exceptionMessage = _data["exceptionMessage"] !== undefined ? _data["exceptionMessage"] : <any>null;
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : <any>null;
            this.sessionDump = _data["sessionDump"] !== undefined ? _data["sessionDump"] : <any>null;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUrl"] = this.requestUrl !== undefined ? this.requestUrl : <any>null;
        data["machineName"] = this.machineName !== undefined ? this.machineName : <any>null;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>null;
        data["requestPath"] = this.requestPath !== undefined ? this.requestPath : <any>null;
        data["userHostAddress"] = this.userHostAddress !== undefined ? this.userHostAddress : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["exception"] = this.exception !== undefined ? this.exception : <any>null;
        data["exceptionCode"] = this.exceptionCode !== undefined ? this.exceptionCode : <any>null;
        data["exceptionMessage"] = this.exceptionMessage !== undefined ? this.exceptionMessage : <any>null;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        data["sessionDump"] = this.sessionDump !== undefined ? this.sessionDump : <any>null;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IErrorV1Model {
    requestUrl?: string | null;
    machineName?: string | null;
    eventTime?: Date;
    requestPath?: string | null;
    userHostAddress?: string | null;
    message?: string | null;
    exception?: string | null;
    exceptionCode?: string | null;
    exceptionMessage?: string | null;
    stackTrace?: string | null;
    sessionDump?: string | null;
    applicationName?: string | null;
    accountId?: number | null;
    userId?: number | null;
}

export class FieldLevelHelpV1Model implements IFieldLevelHelpV1Model {
    helpContentId?: number;
    contentDesc?: string | null;
    whereUsed?: string | null;
    contentText?: string | null;
    createdDate?: Date | null;

    constructor(data?: IFieldLevelHelpV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.helpContentId = _data["helpContentId"] !== undefined ? _data["helpContentId"] : <any>null;
            this.contentDesc = _data["contentDesc"] !== undefined ? _data["contentDesc"] : <any>null;
            this.whereUsed = _data["whereUsed"] !== undefined ? _data["whereUsed"] : <any>null;
            this.contentText = _data["contentText"] !== undefined ? _data["contentText"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): FieldLevelHelpV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLevelHelpV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["helpContentId"] = this.helpContentId !== undefined ? this.helpContentId : <any>null;
        data["contentDesc"] = this.contentDesc !== undefined ? this.contentDesc : <any>null;
        data["whereUsed"] = this.whereUsed !== undefined ? this.whereUsed : <any>null;
        data["contentText"] = this.contentText !== undefined ? this.contentText : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        return data;
    }
}

export interface IFieldLevelHelpV1Model {
    helpContentId?: number;
    contentDesc?: string | null;
    whereUsed?: string | null;
    contentText?: string | null;
    createdDate?: Date | null;
}

export class TimesheetV1Model implements ITimesheetV1Model {
    weekEnd?: Date;
    employees?: TimesheetEmployeeV1Model[] | null;

    constructor(data?: ITimesheetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekEnd = _data["weekEnd"] ? new Date(_data["weekEnd"].toString()) : <any>null;
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(TimesheetEmployeeV1Model.fromJS(item));
            }
            else {
                this.employees = <any>null;
            }
        }
    }

    static fromJS(data: any): TimesheetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekEnd"] = this.weekEnd ? this.weekEnd.toISOString() : <any>null;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimesheetV1Model {
    weekEnd?: Date;
    employees?: TimesheetEmployeeV1Model[] | null;
}

export class TimesheetEmployeeV1Model implements ITimesheetEmployeeV1Model {
    employeeId?: number;
    employeeName?: string | null;
    employeeNumber?: string | null;
    unionCode?: string | null;
    skillLevel?: string | null;
    jobs?: TimesheetEmployeeJobV1Model[] | null;

    constructor(data?: ITimesheetEmployeeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employeeName = _data["employeeName"] !== undefined ? _data["employeeName"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.unionCode = _data["unionCode"] !== undefined ? _data["unionCode"] : <any>null;
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(TimesheetEmployeeJobV1Model.fromJS(item));
            }
            else {
                this.jobs = <any>null;
            }
        }
    }

    static fromJS(data: any): TimesheetEmployeeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEmployeeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employeeName"] = this.employeeName !== undefined ? this.employeeName : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["unionCode"] = this.unionCode !== undefined ? this.unionCode : <any>null;
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimesheetEmployeeV1Model {
    employeeId?: number;
    employeeName?: string | null;
    employeeNumber?: string | null;
    unionCode?: string | null;
    skillLevel?: string | null;
    jobs?: TimesheetEmployeeJobV1Model[] | null;
}

export class TimesheetEmployeeJobV1Model implements ITimesheetEmployeeJobV1Model {
    jobId?: number;
    jobNumber?: string | null;
    costCodeId?: number;
    costCode?: string | null;
    taskName?: string | null;
    isApproved?: boolean;
    sundayStandardHours?: number;
    sundayOvertimeHours?: number;
    sundayWeldInches?: number;
    sundayCostCodeId?: number | null;
    sundayCostCode?: string | null;
    mondayStandardHours?: number;
    mondayOvertimeHours?: number;
    mondayWeldInches?: number;
    mondayCostCodeId?: number | null;
    mondayCostCode?: string | null;
    tuesdayStandardHours?: number;
    tuesdayOvertimeHours?: number;
    tuesdayWeldInches?: number;
    tuesdayCostCodeId?: number | null;
    tuesdayCostCode?: string | null;
    wednesdayStandardHours?: number;
    wednesdayOvertimeHours?: number;
    wednesdayWeldInches?: number;
    wednesdayCostCodeId?: number | null;
    wednesdayCostCode?: string | null;
    thursdayStandardHours?: number;
    thursdayOvertimeHours?: number;
    thursdayWeldInches?: number;
    thursdayCostCodeId?: number | null;
    thursdayCostCode?: string | null;
    fridayStandardHours?: number;
    fridayOvertimeHours?: number;
    fridayWeldInches?: number;
    fridayCostCodeId?: number | null;
    fridayCostCode?: string | null;
    saturdayStandardHours?: number;
    saturdayOvertimeHours?: number;
    saturdayWeldInches?: number;
    saturdayCostCodeId?: number | null;
    saturdayCostCode?: string | null;

    constructor(data?: ITimesheetEmployeeJobV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.costCode = _data["costCode"] !== undefined ? _data["costCode"] : <any>null;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : <any>null;
            this.sundayStandardHours = _data["sundayStandardHours"] !== undefined ? _data["sundayStandardHours"] : <any>null;
            this.sundayOvertimeHours = _data["sundayOvertimeHours"] !== undefined ? _data["sundayOvertimeHours"] : <any>null;
            this.sundayWeldInches = _data["sundayWeldInches"] !== undefined ? _data["sundayWeldInches"] : <any>null;
            this.sundayCostCodeId = _data["sundayCostCodeId"] !== undefined ? _data["sundayCostCodeId"] : <any>null;
            this.sundayCostCode = _data["sundayCostCode"] !== undefined ? _data["sundayCostCode"] : <any>null;
            this.mondayStandardHours = _data["mondayStandardHours"] !== undefined ? _data["mondayStandardHours"] : <any>null;
            this.mondayOvertimeHours = _data["mondayOvertimeHours"] !== undefined ? _data["mondayOvertimeHours"] : <any>null;
            this.mondayWeldInches = _data["mondayWeldInches"] !== undefined ? _data["mondayWeldInches"] : <any>null;
            this.mondayCostCodeId = _data["mondayCostCodeId"] !== undefined ? _data["mondayCostCodeId"] : <any>null;
            this.mondayCostCode = _data["mondayCostCode"] !== undefined ? _data["mondayCostCode"] : <any>null;
            this.tuesdayStandardHours = _data["tuesdayStandardHours"] !== undefined ? _data["tuesdayStandardHours"] : <any>null;
            this.tuesdayOvertimeHours = _data["tuesdayOvertimeHours"] !== undefined ? _data["tuesdayOvertimeHours"] : <any>null;
            this.tuesdayWeldInches = _data["tuesdayWeldInches"] !== undefined ? _data["tuesdayWeldInches"] : <any>null;
            this.tuesdayCostCodeId = _data["tuesdayCostCodeId"] !== undefined ? _data["tuesdayCostCodeId"] : <any>null;
            this.tuesdayCostCode = _data["tuesdayCostCode"] !== undefined ? _data["tuesdayCostCode"] : <any>null;
            this.wednesdayStandardHours = _data["wednesdayStandardHours"] !== undefined ? _data["wednesdayStandardHours"] : <any>null;
            this.wednesdayOvertimeHours = _data["wednesdayOvertimeHours"] !== undefined ? _data["wednesdayOvertimeHours"] : <any>null;
            this.wednesdayWeldInches = _data["wednesdayWeldInches"] !== undefined ? _data["wednesdayWeldInches"] : <any>null;
            this.wednesdayCostCodeId = _data["wednesdayCostCodeId"] !== undefined ? _data["wednesdayCostCodeId"] : <any>null;
            this.wednesdayCostCode = _data["wednesdayCostCode"] !== undefined ? _data["wednesdayCostCode"] : <any>null;
            this.thursdayStandardHours = _data["thursdayStandardHours"] !== undefined ? _data["thursdayStandardHours"] : <any>null;
            this.thursdayOvertimeHours = _data["thursdayOvertimeHours"] !== undefined ? _data["thursdayOvertimeHours"] : <any>null;
            this.thursdayWeldInches = _data["thursdayWeldInches"] !== undefined ? _data["thursdayWeldInches"] : <any>null;
            this.thursdayCostCodeId = _data["thursdayCostCodeId"] !== undefined ? _data["thursdayCostCodeId"] : <any>null;
            this.thursdayCostCode = _data["thursdayCostCode"] !== undefined ? _data["thursdayCostCode"] : <any>null;
            this.fridayStandardHours = _data["fridayStandardHours"] !== undefined ? _data["fridayStandardHours"] : <any>null;
            this.fridayOvertimeHours = _data["fridayOvertimeHours"] !== undefined ? _data["fridayOvertimeHours"] : <any>null;
            this.fridayWeldInches = _data["fridayWeldInches"] !== undefined ? _data["fridayWeldInches"] : <any>null;
            this.fridayCostCodeId = _data["fridayCostCodeId"] !== undefined ? _data["fridayCostCodeId"] : <any>null;
            this.fridayCostCode = _data["fridayCostCode"] !== undefined ? _data["fridayCostCode"] : <any>null;
            this.saturdayStandardHours = _data["saturdayStandardHours"] !== undefined ? _data["saturdayStandardHours"] : <any>null;
            this.saturdayOvertimeHours = _data["saturdayOvertimeHours"] !== undefined ? _data["saturdayOvertimeHours"] : <any>null;
            this.saturdayWeldInches = _data["saturdayWeldInches"] !== undefined ? _data["saturdayWeldInches"] : <any>null;
            this.saturdayCostCodeId = _data["saturdayCostCodeId"] !== undefined ? _data["saturdayCostCodeId"] : <any>null;
            this.saturdayCostCode = _data["saturdayCostCode"] !== undefined ? _data["saturdayCostCode"] : <any>null;
        }
    }

    static fromJS(data: any): TimesheetEmployeeJobV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEmployeeJobV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["costCode"] = this.costCode !== undefined ? this.costCode : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : <any>null;
        data["sundayStandardHours"] = this.sundayStandardHours !== undefined ? this.sundayStandardHours : <any>null;
        data["sundayOvertimeHours"] = this.sundayOvertimeHours !== undefined ? this.sundayOvertimeHours : <any>null;
        data["sundayWeldInches"] = this.sundayWeldInches !== undefined ? this.sundayWeldInches : <any>null;
        data["sundayCostCodeId"] = this.sundayCostCodeId !== undefined ? this.sundayCostCodeId : <any>null;
        data["sundayCostCode"] = this.sundayCostCode !== undefined ? this.sundayCostCode : <any>null;
        data["mondayStandardHours"] = this.mondayStandardHours !== undefined ? this.mondayStandardHours : <any>null;
        data["mondayOvertimeHours"] = this.mondayOvertimeHours !== undefined ? this.mondayOvertimeHours : <any>null;
        data["mondayWeldInches"] = this.mondayWeldInches !== undefined ? this.mondayWeldInches : <any>null;
        data["mondayCostCodeId"] = this.mondayCostCodeId !== undefined ? this.mondayCostCodeId : <any>null;
        data["mondayCostCode"] = this.mondayCostCode !== undefined ? this.mondayCostCode : <any>null;
        data["tuesdayStandardHours"] = this.tuesdayStandardHours !== undefined ? this.tuesdayStandardHours : <any>null;
        data["tuesdayOvertimeHours"] = this.tuesdayOvertimeHours !== undefined ? this.tuesdayOvertimeHours : <any>null;
        data["tuesdayWeldInches"] = this.tuesdayWeldInches !== undefined ? this.tuesdayWeldInches : <any>null;
        data["tuesdayCostCodeId"] = this.tuesdayCostCodeId !== undefined ? this.tuesdayCostCodeId : <any>null;
        data["tuesdayCostCode"] = this.tuesdayCostCode !== undefined ? this.tuesdayCostCode : <any>null;
        data["wednesdayStandardHours"] = this.wednesdayStandardHours !== undefined ? this.wednesdayStandardHours : <any>null;
        data["wednesdayOvertimeHours"] = this.wednesdayOvertimeHours !== undefined ? this.wednesdayOvertimeHours : <any>null;
        data["wednesdayWeldInches"] = this.wednesdayWeldInches !== undefined ? this.wednesdayWeldInches : <any>null;
        data["wednesdayCostCodeId"] = this.wednesdayCostCodeId !== undefined ? this.wednesdayCostCodeId : <any>null;
        data["wednesdayCostCode"] = this.wednesdayCostCode !== undefined ? this.wednesdayCostCode : <any>null;
        data["thursdayStandardHours"] = this.thursdayStandardHours !== undefined ? this.thursdayStandardHours : <any>null;
        data["thursdayOvertimeHours"] = this.thursdayOvertimeHours !== undefined ? this.thursdayOvertimeHours : <any>null;
        data["thursdayWeldInches"] = this.thursdayWeldInches !== undefined ? this.thursdayWeldInches : <any>null;
        data["thursdayCostCodeId"] = this.thursdayCostCodeId !== undefined ? this.thursdayCostCodeId : <any>null;
        data["thursdayCostCode"] = this.thursdayCostCode !== undefined ? this.thursdayCostCode : <any>null;
        data["fridayStandardHours"] = this.fridayStandardHours !== undefined ? this.fridayStandardHours : <any>null;
        data["fridayOvertimeHours"] = this.fridayOvertimeHours !== undefined ? this.fridayOvertimeHours : <any>null;
        data["fridayWeldInches"] = this.fridayWeldInches !== undefined ? this.fridayWeldInches : <any>null;
        data["fridayCostCodeId"] = this.fridayCostCodeId !== undefined ? this.fridayCostCodeId : <any>null;
        data["fridayCostCode"] = this.fridayCostCode !== undefined ? this.fridayCostCode : <any>null;
        data["saturdayStandardHours"] = this.saturdayStandardHours !== undefined ? this.saturdayStandardHours : <any>null;
        data["saturdayOvertimeHours"] = this.saturdayOvertimeHours !== undefined ? this.saturdayOvertimeHours : <any>null;
        data["saturdayWeldInches"] = this.saturdayWeldInches !== undefined ? this.saturdayWeldInches : <any>null;
        data["saturdayCostCodeId"] = this.saturdayCostCodeId !== undefined ? this.saturdayCostCodeId : <any>null;
        data["saturdayCostCode"] = this.saturdayCostCode !== undefined ? this.saturdayCostCode : <any>null;
        return data;
    }
}

export interface ITimesheetEmployeeJobV1Model {
    jobId?: number;
    jobNumber?: string | null;
    costCodeId?: number;
    costCode?: string | null;
    taskName?: string | null;
    isApproved?: boolean;
    sundayStandardHours?: number;
    sundayOvertimeHours?: number;
    sundayWeldInches?: number;
    sundayCostCodeId?: number | null;
    sundayCostCode?: string | null;
    mondayStandardHours?: number;
    mondayOvertimeHours?: number;
    mondayWeldInches?: number;
    mondayCostCodeId?: number | null;
    mondayCostCode?: string | null;
    tuesdayStandardHours?: number;
    tuesdayOvertimeHours?: number;
    tuesdayWeldInches?: number;
    tuesdayCostCodeId?: number | null;
    tuesdayCostCode?: string | null;
    wednesdayStandardHours?: number;
    wednesdayOvertimeHours?: number;
    wednesdayWeldInches?: number;
    wednesdayCostCodeId?: number | null;
    wednesdayCostCode?: string | null;
    thursdayStandardHours?: number;
    thursdayOvertimeHours?: number;
    thursdayWeldInches?: number;
    thursdayCostCodeId?: number | null;
    thursdayCostCode?: string | null;
    fridayStandardHours?: number;
    fridayOvertimeHours?: number;
    fridayWeldInches?: number;
    fridayCostCodeId?: number | null;
    fridayCostCode?: string | null;
    saturdayStandardHours?: number;
    saturdayOvertimeHours?: number;
    saturdayWeldInches?: number;
    saturdayCostCodeId?: number | null;
    saturdayCostCode?: string | null;
}

export class TimesheetSearchV1Model implements ITimesheetSearchV1Model {
    weekEnd?: Date;

    constructor(data?: ITimesheetSearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekEnd = _data["weekEnd"] ? new Date(_data["weekEnd"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): TimesheetSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetSearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekEnd"] = this.weekEnd ? this.weekEnd.toISOString() : <any>null;
        return data;
    }
}

export interface ITimesheetSearchV1Model {
    weekEnd?: Date;
}

export class CostReportV1Model implements ICostReportV1Model {
    fileName?: string | null;
    fileBase64?: string | null;
    contentType?: string | null;

    constructor(data?: ICostReportV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
        }
    }

    static fromJS(data: any): CostReportV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CostReportV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        return data;
    }
}

export interface ICostReportV1Model {
    fileName?: string | null;
    fileBase64?: string | null;
    contentType?: string | null;
}

export class CostReportSearchV1Model implements ICostReportSearchV1Model {
    jobId?: number | null;
    employeeId?: number | null;
    costCodeId?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    skillLevelId?: number | null;

    constructor(data?: ICostReportSearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
        }
    }

    static fromJS(data: any): CostReportSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CostReportSearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        return data;
    }
}

export interface ICostReportSearchV1Model {
    jobId?: number | null;
    employeeId?: number | null;
    costCodeId?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    skillLevelId?: number | null;
}

export class TimesheetEditV1Model implements ITimesheetEditV1Model {
    oldJobId?: number;
    newJobId?: number;
    employeeId?: number;
    oldCostCodeId?: number;
    newCostCodeId?: number;
    weekEnd?: Date;

    constructor(data?: ITimesheetEditV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldJobId = _data["oldJobId"] !== undefined ? _data["oldJobId"] : <any>null;
            this.newJobId = _data["newJobId"] !== undefined ? _data["newJobId"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.oldCostCodeId = _data["oldCostCodeId"] !== undefined ? _data["oldCostCodeId"] : <any>null;
            this.newCostCodeId = _data["newCostCodeId"] !== undefined ? _data["newCostCodeId"] : <any>null;
            this.weekEnd = _data["weekEnd"] ? new Date(_data["weekEnd"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): TimesheetEditV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEditV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldJobId"] = this.oldJobId !== undefined ? this.oldJobId : <any>null;
        data["newJobId"] = this.newJobId !== undefined ? this.newJobId : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["oldCostCodeId"] = this.oldCostCodeId !== undefined ? this.oldCostCodeId : <any>null;
        data["newCostCodeId"] = this.newCostCodeId !== undefined ? this.newCostCodeId : <any>null;
        data["weekEnd"] = this.weekEnd ? this.weekEnd.toISOString() : <any>null;
        return data;
    }
}

export interface ITimesheetEditV1Model {
    oldJobId?: number;
    newJobId?: number;
    employeeId?: number;
    oldCostCodeId?: number;
    newCostCodeId?: number;
    weekEnd?: Date;
}

export class TimesheetNewV1Model implements ITimesheetNewV1Model {
    jobId?: number;
    employeeId?: number;
    costCodeId?: number;
    weekEnd?: Date;
    sundayStandardHours?: number | null;
    sundayOvertimeHours?: number | null;
    sundayWeldInches?: number | null;
    mondayStandardHours?: number | null;
    mondayOvertimeHours?: number | null;
    mondayWeldInches?: number | null;
    tuesdayStandardHours?: number | null;
    tuesdayOvertimeHours?: number | null;
    tuesdayWeldInches?: number | null;
    wednesdayStandardHours?: number | null;
    wednesdayOvertimeHours?: number | null;
    wednesdayWeldInches?: number | null;
    thursdayStandardHours?: number | null;
    thursdayOvertimeHours?: number | null;
    thursdayWeldInches?: number | null;
    fridayStandardHours?: number | null;
    fridayOvertimeHours?: number | null;
    fridayWeldInches?: number | null;
    saturdayStandardHours?: number | null;
    saturdayOvertimeHours?: number | null;
    saturdayWeldInches?: number | null;

    constructor(data?: ITimesheetNewV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.weekEnd = _data["weekEnd"] ? new Date(_data["weekEnd"].toString()) : <any>null;
            this.sundayStandardHours = _data["sundayStandardHours"] !== undefined ? _data["sundayStandardHours"] : <any>null;
            this.sundayOvertimeHours = _data["sundayOvertimeHours"] !== undefined ? _data["sundayOvertimeHours"] : <any>null;
            this.sundayWeldInches = _data["sundayWeldInches"] !== undefined ? _data["sundayWeldInches"] : <any>null;
            this.mondayStandardHours = _data["mondayStandardHours"] !== undefined ? _data["mondayStandardHours"] : <any>null;
            this.mondayOvertimeHours = _data["mondayOvertimeHours"] !== undefined ? _data["mondayOvertimeHours"] : <any>null;
            this.mondayWeldInches = _data["mondayWeldInches"] !== undefined ? _data["mondayWeldInches"] : <any>null;
            this.tuesdayStandardHours = _data["tuesdayStandardHours"] !== undefined ? _data["tuesdayStandardHours"] : <any>null;
            this.tuesdayOvertimeHours = _data["tuesdayOvertimeHours"] !== undefined ? _data["tuesdayOvertimeHours"] : <any>null;
            this.tuesdayWeldInches = _data["tuesdayWeldInches"] !== undefined ? _data["tuesdayWeldInches"] : <any>null;
            this.wednesdayStandardHours = _data["wednesdayStandardHours"] !== undefined ? _data["wednesdayStandardHours"] : <any>null;
            this.wednesdayOvertimeHours = _data["wednesdayOvertimeHours"] !== undefined ? _data["wednesdayOvertimeHours"] : <any>null;
            this.wednesdayWeldInches = _data["wednesdayWeldInches"] !== undefined ? _data["wednesdayWeldInches"] : <any>null;
            this.thursdayStandardHours = _data["thursdayStandardHours"] !== undefined ? _data["thursdayStandardHours"] : <any>null;
            this.thursdayOvertimeHours = _data["thursdayOvertimeHours"] !== undefined ? _data["thursdayOvertimeHours"] : <any>null;
            this.thursdayWeldInches = _data["thursdayWeldInches"] !== undefined ? _data["thursdayWeldInches"] : <any>null;
            this.fridayStandardHours = _data["fridayStandardHours"] !== undefined ? _data["fridayStandardHours"] : <any>null;
            this.fridayOvertimeHours = _data["fridayOvertimeHours"] !== undefined ? _data["fridayOvertimeHours"] : <any>null;
            this.fridayWeldInches = _data["fridayWeldInches"] !== undefined ? _data["fridayWeldInches"] : <any>null;
            this.saturdayStandardHours = _data["saturdayStandardHours"] !== undefined ? _data["saturdayStandardHours"] : <any>null;
            this.saturdayOvertimeHours = _data["saturdayOvertimeHours"] !== undefined ? _data["saturdayOvertimeHours"] : <any>null;
            this.saturdayWeldInches = _data["saturdayWeldInches"] !== undefined ? _data["saturdayWeldInches"] : <any>null;
        }
    }

    static fromJS(data: any): TimesheetNewV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetNewV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["weekEnd"] = this.weekEnd ? this.weekEnd.toISOString() : <any>null;
        data["sundayStandardHours"] = this.sundayStandardHours !== undefined ? this.sundayStandardHours : <any>null;
        data["sundayOvertimeHours"] = this.sundayOvertimeHours !== undefined ? this.sundayOvertimeHours : <any>null;
        data["sundayWeldInches"] = this.sundayWeldInches !== undefined ? this.sundayWeldInches : <any>null;
        data["mondayStandardHours"] = this.mondayStandardHours !== undefined ? this.mondayStandardHours : <any>null;
        data["mondayOvertimeHours"] = this.mondayOvertimeHours !== undefined ? this.mondayOvertimeHours : <any>null;
        data["mondayWeldInches"] = this.mondayWeldInches !== undefined ? this.mondayWeldInches : <any>null;
        data["tuesdayStandardHours"] = this.tuesdayStandardHours !== undefined ? this.tuesdayStandardHours : <any>null;
        data["tuesdayOvertimeHours"] = this.tuesdayOvertimeHours !== undefined ? this.tuesdayOvertimeHours : <any>null;
        data["tuesdayWeldInches"] = this.tuesdayWeldInches !== undefined ? this.tuesdayWeldInches : <any>null;
        data["wednesdayStandardHours"] = this.wednesdayStandardHours !== undefined ? this.wednesdayStandardHours : <any>null;
        data["wednesdayOvertimeHours"] = this.wednesdayOvertimeHours !== undefined ? this.wednesdayOvertimeHours : <any>null;
        data["wednesdayWeldInches"] = this.wednesdayWeldInches !== undefined ? this.wednesdayWeldInches : <any>null;
        data["thursdayStandardHours"] = this.thursdayStandardHours !== undefined ? this.thursdayStandardHours : <any>null;
        data["thursdayOvertimeHours"] = this.thursdayOvertimeHours !== undefined ? this.thursdayOvertimeHours : <any>null;
        data["thursdayWeldInches"] = this.thursdayWeldInches !== undefined ? this.thursdayWeldInches : <any>null;
        data["fridayStandardHours"] = this.fridayStandardHours !== undefined ? this.fridayStandardHours : <any>null;
        data["fridayOvertimeHours"] = this.fridayOvertimeHours !== undefined ? this.fridayOvertimeHours : <any>null;
        data["fridayWeldInches"] = this.fridayWeldInches !== undefined ? this.fridayWeldInches : <any>null;
        data["saturdayStandardHours"] = this.saturdayStandardHours !== undefined ? this.saturdayStandardHours : <any>null;
        data["saturdayOvertimeHours"] = this.saturdayOvertimeHours !== undefined ? this.saturdayOvertimeHours : <any>null;
        data["saturdayWeldInches"] = this.saturdayWeldInches !== undefined ? this.saturdayWeldInches : <any>null;
        return data;
    }
}

export interface ITimesheetNewV1Model {
    jobId?: number;
    employeeId?: number;
    costCodeId?: number;
    weekEnd?: Date;
    sundayStandardHours?: number | null;
    sundayOvertimeHours?: number | null;
    sundayWeldInches?: number | null;
    mondayStandardHours?: number | null;
    mondayOvertimeHours?: number | null;
    mondayWeldInches?: number | null;
    tuesdayStandardHours?: number | null;
    tuesdayOvertimeHours?: number | null;
    tuesdayWeldInches?: number | null;
    wednesdayStandardHours?: number | null;
    wednesdayOvertimeHours?: number | null;
    wednesdayWeldInches?: number | null;
    thursdayStandardHours?: number | null;
    thursdayOvertimeHours?: number | null;
    thursdayWeldInches?: number | null;
    fridayStandardHours?: number | null;
    fridayOvertimeHours?: number | null;
    fridayWeldInches?: number | null;
    saturdayStandardHours?: number | null;
    saturdayOvertimeHours?: number | null;
    saturdayWeldInches?: number | null;
}

export class JobLaborInsertV1Model implements IJobLaborInsertV1Model {
    jobId?: number;
    employeeId?: number;
    costCodeId?: number;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;
    dateWorked?: Date;

    constructor(data?: IJobLaborInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.standardHours = _data["standardHours"] !== undefined ? _data["standardHours"] : <any>null;
            this.overtimeHours = _data["overtimeHours"] !== undefined ? _data["overtimeHours"] : <any>null;
            this.weldInches = _data["weldInches"] !== undefined ? _data["weldInches"] : <any>null;
            this.dateWorked = _data["dateWorked"] ? new Date(_data["dateWorked"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobLaborInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLaborInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["standardHours"] = this.standardHours !== undefined ? this.standardHours : <any>null;
        data["overtimeHours"] = this.overtimeHours !== undefined ? this.overtimeHours : <any>null;
        data["weldInches"] = this.weldInches !== undefined ? this.weldInches : <any>null;
        data["dateWorked"] = this.dateWorked ? this.dateWorked.toISOString() : <any>null;
        return data;
    }
}

export interface IJobLaborInsertV1Model {
    jobId?: number;
    employeeId?: number;
    costCodeId?: number;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;
    dateWorked?: Date;
}

export class SkillLevelCostInsertV1Model implements ISkillLevelCostInsertV1Model {
    skillLevelId?: number;
    regularCost?: number;
    overtimeCost?: number;
    timeOffCost?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;

    constructor(data?: ISkillLevelCostInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.regularCost = _data["regularCost"] !== undefined ? _data["regularCost"] : <any>null;
            this.overtimeCost = _data["overtimeCost"] !== undefined ? _data["overtimeCost"] : <any>null;
            this.timeOffCost = _data["timeOffCost"] !== undefined ? _data["timeOffCost"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SkillLevelCostInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SkillLevelCostInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["regularCost"] = this.regularCost !== undefined ? this.regularCost : <any>null;
        data["overtimeCost"] = this.overtimeCost !== undefined ? this.overtimeCost : <any>null;
        data["timeOffCost"] = this.timeOffCost !== undefined ? this.timeOffCost : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISkillLevelCostInsertV1Model {
    skillLevelId?: number;
    regularCost?: number;
    overtimeCost?: number;
    timeOffCost?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;
}

export class SkillLevelCostUpdateV1Model implements ISkillLevelCostUpdateV1Model {
    skillLevelCostId?: number;
    skillLevelId?: number;
    regularCost?: number;
    overtimeCost?: number;
    timeOffCost?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;

    constructor(data?: ISkillLevelCostUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillLevelCostId = _data["skillLevelCostId"] !== undefined ? _data["skillLevelCostId"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.regularCost = _data["regularCost"] !== undefined ? _data["regularCost"] : <any>null;
            this.overtimeCost = _data["overtimeCost"] !== undefined ? _data["overtimeCost"] : <any>null;
            this.timeOffCost = _data["timeOffCost"] !== undefined ? _data["timeOffCost"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SkillLevelCostUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SkillLevelCostUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillLevelCostId"] = this.skillLevelCostId !== undefined ? this.skillLevelCostId : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["regularCost"] = this.regularCost !== undefined ? this.regularCost : <any>null;
        data["overtimeCost"] = this.overtimeCost !== undefined ? this.overtimeCost : <any>null;
        data["timeOffCost"] = this.timeOffCost !== undefined ? this.timeOffCost : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISkillLevelCostUpdateV1Model {
    skillLevelCostId?: number;
    skillLevelId?: number;
    regularCost?: number;
    overtimeCost?: number;
    timeOffCost?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;
}

export class JobSubcontractorCategoryV1Model implements IJobSubcontractorCategoryV1Model {
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;

    constructor(data?: IJobSubcontractorCategoryV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorCategoryV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorCategoryV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobSubcontractorCategoryV1Model {
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
}

export class JobSubcontractorCategoryInsertV1Model implements IJobSubcontractorCategoryInsertV1Model {
    category?: string | null;
    isActive?: boolean;

    constructor(data?: IJobSubcontractorCategoryInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorCategoryInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorCategoryInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobSubcontractorCategoryInsertV1Model {
    category?: string | null;
    isActive?: boolean;
}

export class JobSubcontractorCategoryUpdateV1Model implements IJobSubcontractorCategoryUpdateV1Model {
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    isActive?: boolean;

    constructor(data?: IJobSubcontractorCategoryUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorCategoryUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorCategoryUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobSubcontractorCategoryUpdateV1Model {
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    isActive?: boolean;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model implements IODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobSubcontractorCategoryV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobSubcontractorCategoryV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobSubcontractorCategoryV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobSubcontractorCategoryV1Model[] | null;
}

export class JobSubcontractorBudgetInsertV1Model implements IJobSubcontractorBudgetInsertV1Model {
    jobId?: number;
    jobSubcontractorCategoryId?: number;
    amount?: number;
    requestedDate?: Date;

    constructor(data?: IJobSubcontractorBudgetInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorBudgetInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorBudgetInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IJobSubcontractorBudgetInsertV1Model {
    jobId?: number;
    jobSubcontractorCategoryId?: number;
    amount?: number;
    requestedDate?: Date;
}

export class JobSubcontractorBudgetV1Model implements IJobSubcontractorBudgetV1Model {
    jobSubcontractorBudgetId?: number;
    jobId?: number;
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    amount?: number;
    requestedDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;

    constructor(data?: IJobSubcontractorBudgetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSubcontractorBudgetId = _data["jobSubcontractorBudgetId"] !== undefined ? _data["jobSubcontractorBudgetId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorBudgetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorBudgetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSubcontractorBudgetId"] = this.jobSubcontractorBudgetId !== undefined ? this.jobSubcontractorBudgetId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        return data;
    }
}

export interface IJobSubcontractorBudgetV1Model {
    jobSubcontractorBudgetId?: number;
    jobId?: number;
    jobSubcontractorCategoryId?: number;
    category?: string | null;
    amount?: number;
    requestedDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
}

export class JobSubcontractorBudgetUpdateV1Model implements IJobSubcontractorBudgetUpdateV1Model {
    jobSubcontractorBudgetId?: number;
    jobId?: number;
    jobSubcontractorCategoryId?: number;
    amount?: number;
    requestedDate?: Date;

    constructor(data?: IJobSubcontractorBudgetUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSubcontractorBudgetId = _data["jobSubcontractorBudgetId"] !== undefined ? _data["jobSubcontractorBudgetId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobSubcontractorCategoryId = _data["jobSubcontractorCategoryId"] !== undefined ? _data["jobSubcontractorCategoryId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobSubcontractorBudgetUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobSubcontractorBudgetUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSubcontractorBudgetId"] = this.jobSubcontractorBudgetId !== undefined ? this.jobSubcontractorBudgetId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobSubcontractorCategoryId"] = this.jobSubcontractorCategoryId !== undefined ? this.jobSubcontractorCategoryId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IJobSubcontractorBudgetUpdateV1Model {
    jobSubcontractorBudgetId?: number;
    jobId?: number;
    jobSubcontractorCategoryId?: number;
    amount?: number;
    requestedDate?: Date;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model implements IODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobSubcontractorBudgetV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobSubcontractorBudgetV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobSubcontractorBudgetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobSubcontractorBudgetV1Model[] | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobMaterialCategoryV1Model implements IODataValueOfIEnumerableOfJobMaterialCategoryV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobMaterialCategoryV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobMaterialCategoryV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobMaterialCategoryV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobMaterialCategoryV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobMaterialCategoryV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobMaterialCategoryV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobMaterialCategoryV1Model[] | null;
}

export class JobMaterialBudgetInsertV1Model implements IJobMaterialBudgetInsertV1Model {
    jobId?: number;
    jobMaterialCategoryId?: number;
    description?: string | null;
    amount?: number;
    requestedDate?: Date;

    constructor(data?: IJobMaterialBudgetInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialBudgetInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialBudgetInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IJobMaterialBudgetInsertV1Model {
    jobId?: number;
    jobMaterialCategoryId?: number;
    description?: string | null;
    amount?: number;
    requestedDate?: Date;
}

export class JobMaterialBudgetV1Model implements IJobMaterialBudgetV1Model {
    jobMaterialBudgetId?: number;
    jobId?: number;
    jobMaterialCategoryId?: number;
    description?: string | null;
    category?: string | null;
    amount?: number;
    requestedDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;

    constructor(data?: IJobMaterialBudgetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialBudgetId = _data["jobMaterialBudgetId"] !== undefined ? _data["jobMaterialBudgetId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialBudgetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialBudgetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialBudgetId"] = this.jobMaterialBudgetId !== undefined ? this.jobMaterialBudgetId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        return data;
    }
}

export interface IJobMaterialBudgetV1Model {
    jobMaterialBudgetId?: number;
    jobId?: number;
    jobMaterialCategoryId?: number;
    description?: string | null;
    category?: string | null;
    amount?: number;
    requestedDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
}

export class JobMaterialBudgetUpdateV1Model implements IJobMaterialBudgetUpdateV1Model {
    jobMaterialBudgetId?: number;
    jobId?: number;
    jobMaterialCategoryId?: number;
    category?: string | null;
    description?: string | null;
    amount?: number;
    requestedDate?: Date;

    constructor(data?: IJobMaterialBudgetUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialBudgetId = _data["jobMaterialBudgetId"] !== undefined ? _data["jobMaterialBudgetId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobMaterialCategoryId = _data["jobMaterialCategoryId"] !== undefined ? _data["jobMaterialCategoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobMaterialBudgetUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialBudgetUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialBudgetId"] = this.jobMaterialBudgetId !== undefined ? this.jobMaterialBudgetId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobMaterialCategoryId"] = this.jobMaterialCategoryId !== undefined ? this.jobMaterialCategoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IJobMaterialBudgetUpdateV1Model {
    jobMaterialBudgetId?: number;
    jobId?: number;
    jobMaterialCategoryId?: number;
    category?: string | null;
    description?: string | null;
    amount?: number;
    requestedDate?: Date;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobMaterialBudgetV1Model implements IODataValueOfIEnumerableOfJobMaterialBudgetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobMaterialBudgetV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobMaterialBudgetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobMaterialBudgetV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobMaterialBudgetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobMaterialBudgetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobMaterialBudgetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobMaterialBudgetV1Model[] | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobLaborBudgetV1Model implements IODataValueOfIEnumerableOfJobLaborBudgetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobLaborBudgetV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobLaborBudgetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobLaborBudgetV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobLaborBudgetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobLaborBudgetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobLaborBudgetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobLaborBudgetV1Model[] | null;
}

export class JobLaborBudgetV1Model implements IJobLaborBudgetV1Model {
    jobLaborBudgetId?: number;
    jobId?: number;
    jobNumber?: string | null;
    costCodeId?: number;
    costCode?: number;
    taskName?: string | null;
    totalHours?: number;
    totalCost?: number;
    requestedDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    createdByUserName?: string | null;
    updatedDate?: Date;
    updatedByUserId?: number;
    updatedByUserName?: string | null;

    constructor(data?: IJobLaborBudgetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLaborBudgetId = _data["jobLaborBudgetId"] !== undefined ? _data["jobLaborBudgetId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.costCode = _data["costCode"] !== undefined ? _data["costCode"] : <any>null;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
            this.totalHours = _data["totalHours"] !== undefined ? _data["totalHours"] : <any>null;
            this.totalCost = _data["totalCost"] !== undefined ? _data["totalCost"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUserName = _data["createdByUserName"] !== undefined ? _data["createdByUserName"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUserName = _data["updatedByUserName"] !== undefined ? _data["updatedByUserName"] : <any>null;
        }
    }

    static fromJS(data: any): JobLaborBudgetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLaborBudgetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLaborBudgetId"] = this.jobLaborBudgetId !== undefined ? this.jobLaborBudgetId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["costCode"] = this.costCode !== undefined ? this.costCode : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["totalHours"] = this.totalHours !== undefined ? this.totalHours : <any>null;
        data["totalCost"] = this.totalCost !== undefined ? this.totalCost : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUserName"] = this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUserName"] = this.updatedByUserName !== undefined ? this.updatedByUserName : <any>null;
        return data;
    }
}

export interface IJobLaborBudgetV1Model {
    jobLaborBudgetId?: number;
    jobId?: number;
    jobNumber?: string | null;
    costCodeId?: number;
    costCode?: number;
    taskName?: string | null;
    totalHours?: number;
    totalCost?: number;
    requestedDate?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    createdByUserName?: string | null;
    updatedDate?: Date;
    updatedByUserId?: number;
    updatedByUserName?: string | null;
}

export class JobLaborV1Model implements IJobLaborV1Model {
    jobLaborId?: number;
    jobId?: number;
    jobNumber?: string | null;
    employeeId?: number;
    employee?: string | null;
    employeeNumber?: string | null;
    skillLevelId?: number;
    skillLevel?: string | null;
    unionCode?: string | null;
    costCodeId?: number;
    costCode?: string | null;
    taskName?: string | null;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;
    dateWorked?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
    isApproved?: boolean;

    constructor(data?: IJobLaborV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLaborId = _data["jobLaborId"] !== undefined ? _data["jobLaborId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employee = _data["employee"] !== undefined ? _data["employee"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            this.unionCode = _data["unionCode"] !== undefined ? _data["unionCode"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.costCode = _data["costCode"] !== undefined ? _data["costCode"] : <any>null;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
            this.standardHours = _data["standardHours"] !== undefined ? _data["standardHours"] : <any>null;
            this.overtimeHours = _data["overtimeHours"] !== undefined ? _data["overtimeHours"] : <any>null;
            this.weldInches = _data["weldInches"] !== undefined ? _data["weldInches"] : <any>null;
            this.dateWorked = _data["dateWorked"] ? new Date(_data["dateWorked"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : <any>null;
        }
    }

    static fromJS(data: any): JobLaborV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLaborV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLaborId"] = this.jobLaborId !== undefined ? this.jobLaborId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employee"] = this.employee !== undefined ? this.employee : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        data["unionCode"] = this.unionCode !== undefined ? this.unionCode : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["costCode"] = this.costCode !== undefined ? this.costCode : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["standardHours"] = this.standardHours !== undefined ? this.standardHours : <any>null;
        data["overtimeHours"] = this.overtimeHours !== undefined ? this.overtimeHours : <any>null;
        data["weldInches"] = this.weldInches !== undefined ? this.weldInches : <any>null;
        data["dateWorked"] = this.dateWorked ? this.dateWorked.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : <any>null;
        return data;
    }
}

export interface IJobLaborV1Model {
    jobLaborId?: number;
    jobId?: number;
    jobNumber?: string | null;
    employeeId?: number;
    employee?: string | null;
    employeeNumber?: string | null;
    skillLevelId?: number;
    skillLevel?: string | null;
    unionCode?: string | null;
    costCodeId?: number;
    costCode?: string | null;
    taskName?: string | null;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;
    dateWorked?: Date;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number;
    isActive?: boolean;
    isApproved?: boolean;
}

export class JobLaborUpdateV1Model implements IJobLaborUpdateV1Model {
    jobLaborId?: number;
    jobId?: number;
    employeeId?: number;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;
    dateWorked?: Date;
    isActive?: boolean;

    constructor(data?: IJobLaborUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLaborId = _data["jobLaborId"] !== undefined ? _data["jobLaborId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.standardHours = _data["standardHours"] !== undefined ? _data["standardHours"] : <any>null;
            this.overtimeHours = _data["overtimeHours"] !== undefined ? _data["overtimeHours"] : <any>null;
            this.weldInches = _data["weldInches"] !== undefined ? _data["weldInches"] : <any>null;
            this.dateWorked = _data["dateWorked"] ? new Date(_data["dateWorked"].toString()) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): JobLaborUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLaborUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLaborId"] = this.jobLaborId !== undefined ? this.jobLaborId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["standardHours"] = this.standardHours !== undefined ? this.standardHours : <any>null;
        data["overtimeHours"] = this.overtimeHours !== undefined ? this.overtimeHours : <any>null;
        data["weldInches"] = this.weldInches !== undefined ? this.weldInches : <any>null;
        data["dateWorked"] = this.dateWorked ? this.dateWorked.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IJobLaborUpdateV1Model {
    jobLaborId?: number;
    jobId?: number;
    employeeId?: number;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;
    dateWorked?: Date;
    isActive?: boolean;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobLaborGroupedV1Model implements IODataValueOfIEnumerableOfJobLaborGroupedV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobLaborGroupedV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobLaborGroupedV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobLaborGroupedV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobLaborGroupedV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobLaborGroupedV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobLaborGroupedV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobLaborGroupedV1Model[] | null;
}

export class JobLaborGroupedV1Model implements IJobLaborGroupedV1Model {
    jobLaborId?: number;
    jobId?: number;
    jobNumber?: string | null;
    employeeId?: number;
    employee?: string | null;
    employeeNumber?: string | null;
    skillLevelId?: number;
    skillLevel?: string | null;
    unionCode?: string | null;
    costCodeId?: number;
    costCode?: string | null;
    taskName?: string | null;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;

    constructor(data?: IJobLaborGroupedV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLaborId = _data["jobLaborId"] !== undefined ? _data["jobLaborId"] : <any>null;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employee = _data["employee"] !== undefined ? _data["employee"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.skillLevelId = _data["skillLevelId"] !== undefined ? _data["skillLevelId"] : <any>null;
            this.skillLevel = _data["skillLevel"] !== undefined ? _data["skillLevel"] : <any>null;
            this.unionCode = _data["unionCode"] !== undefined ? _data["unionCode"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.costCode = _data["costCode"] !== undefined ? _data["costCode"] : <any>null;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
            this.standardHours = _data["standardHours"] !== undefined ? _data["standardHours"] : <any>null;
            this.overtimeHours = _data["overtimeHours"] !== undefined ? _data["overtimeHours"] : <any>null;
            this.weldInches = _data["weldInches"] !== undefined ? _data["weldInches"] : <any>null;
        }
    }

    static fromJS(data: any): JobLaborGroupedV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLaborGroupedV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLaborId"] = this.jobLaborId !== undefined ? this.jobLaborId : <any>null;
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employee"] = this.employee !== undefined ? this.employee : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["skillLevelId"] = this.skillLevelId !== undefined ? this.skillLevelId : <any>null;
        data["skillLevel"] = this.skillLevel !== undefined ? this.skillLevel : <any>null;
        data["unionCode"] = this.unionCode !== undefined ? this.unionCode : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["costCode"] = this.costCode !== undefined ? this.costCode : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["standardHours"] = this.standardHours !== undefined ? this.standardHours : <any>null;
        data["overtimeHours"] = this.overtimeHours !== undefined ? this.overtimeHours : <any>null;
        data["weldInches"] = this.weldInches !== undefined ? this.weldInches : <any>null;
        return data;
    }
}

export interface IJobLaborGroupedV1Model {
    jobLaborId?: number;
    jobId?: number;
    jobNumber?: string | null;
    employeeId?: number;
    employee?: string | null;
    employeeNumber?: string | null;
    skillLevelId?: number;
    skillLevel?: string | null;
    unionCode?: string | null;
    costCodeId?: number;
    costCode?: string | null;
    taskName?: string | null;
    standardHours?: number;
    overtimeHours?: number;
    weldInches?: number;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfJobLaborV1Model implements IODataValueOfIEnumerableOfJobLaborV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobLaborV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfJobLaborV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JobLaborV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfJobLaborV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfJobLaborV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfJobLaborV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: JobLaborV1Model[] | null;
}

export class JobLaborBudgetInsertV1Model implements IJobLaborBudgetInsertV1Model {
    jobId?: number;
    costCodeId?: number;
    totalHours?: number;
    totalCost?: number;
    requestedDate?: Date;

    constructor(data?: IJobLaborBudgetInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.totalHours = _data["totalHours"] !== undefined ? _data["totalHours"] : <any>null;
            this.totalCost = _data["totalCost"] !== undefined ? _data["totalCost"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobLaborBudgetInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLaborBudgetInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["totalHours"] = this.totalHours !== undefined ? this.totalHours : <any>null;
        data["totalCost"] = this.totalCost !== undefined ? this.totalCost : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IJobLaborBudgetInsertV1Model {
    jobId?: number;
    costCodeId?: number;
    totalHours?: number;
    totalCost?: number;
    requestedDate?: Date;
}

export class JobLaborBudgetUpdateV1Model implements IJobLaborBudgetUpdateV1Model {
    jobLaborBudgetId?: number;
    costCodeId?: number;
    totalHours?: number;
    totalCost?: number;
    requestedDate?: Date;

    constructor(data?: IJobLaborBudgetUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLaborBudgetId = _data["jobLaborBudgetId"] !== undefined ? _data["jobLaborBudgetId"] : <any>null;
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.totalHours = _data["totalHours"] !== undefined ? _data["totalHours"] : <any>null;
            this.totalCost = _data["totalCost"] !== undefined ? _data["totalCost"] : <any>null;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JobLaborBudgetUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new JobLaborBudgetUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLaborBudgetId"] = this.jobLaborBudgetId !== undefined ? this.jobLaborBudgetId : <any>null;
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["totalHours"] = this.totalHours !== undefined ? this.totalHours : <any>null;
        data["totalCost"] = this.totalCost !== undefined ? this.totalCost : <any>null;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IJobLaborBudgetUpdateV1Model {
    jobLaborBudgetId?: number;
    costCodeId?: number;
    totalHours?: number;
    totalCost?: number;
    requestedDate?: Date;
}

export class GridColumnV1Model implements IGridColumnV1Model {
    headerText?: string | null;
    visible?: boolean;
    showInColumnChooser?: boolean;
    field?: string | null;
    type?: string | null;
    format?: string | null;
    allowSearching?: boolean;
    isPrimary?: boolean;
    editType?: string | null;
    allowEditing?: boolean;
    clipMode?: string | null;
    template?: string | null;
    columnWidth?: number;
    headerTemplate?: string | null;

    constructor(data?: IGridColumnV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headerText = _data["headerText"] !== undefined ? _data["headerText"] : <any>null;
            this.visible = _data["visible"] !== undefined ? _data["visible"] : <any>null;
            this.showInColumnChooser = _data["showInColumnChooser"] !== undefined ? _data["showInColumnChooser"] : <any>null;
            this.field = _data["field"] !== undefined ? _data["field"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.allowSearching = _data["allowSearching"] !== undefined ? _data["allowSearching"] : <any>null;
            this.isPrimary = _data["isPrimary"] !== undefined ? _data["isPrimary"] : <any>null;
            this.editType = _data["editType"] !== undefined ? _data["editType"] : <any>null;
            this.allowEditing = _data["allowEditing"] !== undefined ? _data["allowEditing"] : <any>null;
            this.clipMode = _data["clipMode"] !== undefined ? _data["clipMode"] : <any>null;
            this.template = _data["template"] !== undefined ? _data["template"] : <any>null;
            this.columnWidth = _data["columnWidth"] !== undefined ? _data["columnWidth"] : <any>null;
            this.headerTemplate = _data["headerTemplate"] !== undefined ? _data["headerTemplate"] : <any>null;
        }
    }

    static fromJS(data: any): GridColumnV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new GridColumnV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerText"] = this.headerText !== undefined ? this.headerText : <any>null;
        data["visible"] = this.visible !== undefined ? this.visible : <any>null;
        data["showInColumnChooser"] = this.showInColumnChooser !== undefined ? this.showInColumnChooser : <any>null;
        data["field"] = this.field !== undefined ? this.field : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["allowSearching"] = this.allowSearching !== undefined ? this.allowSearching : <any>null;
        data["isPrimary"] = this.isPrimary !== undefined ? this.isPrimary : <any>null;
        data["editType"] = this.editType !== undefined ? this.editType : <any>null;
        data["allowEditing"] = this.allowEditing !== undefined ? this.allowEditing : <any>null;
        data["clipMode"] = this.clipMode !== undefined ? this.clipMode : <any>null;
        data["template"] = this.template !== undefined ? this.template : <any>null;
        data["columnWidth"] = this.columnWidth !== undefined ? this.columnWidth : <any>null;
        data["headerTemplate"] = this.headerTemplate !== undefined ? this.headerTemplate : <any>null;
        return data;
    }
}

export interface IGridColumnV1Model {
    headerText?: string | null;
    visible?: boolean;
    showInColumnChooser?: boolean;
    field?: string | null;
    type?: string | null;
    format?: string | null;
    allowSearching?: boolean;
    isPrimary?: boolean;
    editType?: string | null;
    allowEditing?: boolean;
    clipMode?: string | null;
    template?: string | null;
    columnWidth?: number;
    headerTemplate?: string | null;
}

export class CostCodeV1Model implements ICostCodeV1Model {
    costCodeId?: number;
    costCode?: number;
    taskName?: string | null;
    isActive?: boolean;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number | null;

    constructor(data?: ICostCodeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.costCode = _data["costCode"] !== undefined ? _data["costCode"] : <any>null;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
        }
    }

    static fromJS(data: any): CostCodeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CostCodeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["costCode"] = this.costCode !== undefined ? this.costCode : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        return data;
    }
}

export interface ICostCodeV1Model {
    costCodeId?: number;
    costCode?: number;
    taskName?: string | null;
    isActive?: boolean;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number | null;
}

export class CostCodeSearchV1Model extends BaseSearchV1 implements ICostCodeSearchV1Model {
    searchTerm?: string | null;

    constructor(data?: ICostCodeSearchV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : <any>null;
        }
    }

    static override fromJS(data: any): CostCodeSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CostCodeSearchV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICostCodeSearchV1Model extends IBaseSearchV1 {
    searchTerm?: string | null;
}

export class CostCodeInsertV1Model implements ICostCodeInsertV1Model {
    costCode?: number;
    taskName?: string | null;
    isActive?: boolean;

    constructor(data?: ICostCodeInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCode = _data["costCode"] !== undefined ? _data["costCode"] : <any>null;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): CostCodeInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CostCodeInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCode"] = this.costCode !== undefined ? this.costCode : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ICostCodeInsertV1Model {
    costCode?: number;
    taskName?: string | null;
    isActive?: boolean;
}

export class CostCodeUpdateV1Model implements ICostCodeUpdateV1Model {
    costCodeId?: number;
    costCode?: number;
    taskName?: string | null;
    isActive?: boolean;

    constructor(data?: ICostCodeUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCodeId = _data["costCodeId"] !== undefined ? _data["costCodeId"] : <any>null;
            this.costCode = _data["costCode"] !== undefined ? _data["costCode"] : <any>null;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): CostCodeUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CostCodeUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCodeId"] = this.costCodeId !== undefined ? this.costCodeId : <any>null;
        data["costCode"] = this.costCode !== undefined ? this.costCode : <any>null;
        data["taskName"] = this.taskName !== undefined ? this.taskName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ICostCodeUpdateV1Model {
    costCodeId?: number;
    costCode?: number;
    taskName?: string | null;
    isActive?: boolean;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfCostCodeV1Model implements IODataValueOfIEnumerableOfCostCodeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: CostCodeV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfCostCodeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(CostCodeV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfCostCodeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfCostCodeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfCostCodeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: CostCodeV1Model[] | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}